/* Karaoke Studio — main orchestrator.
   Extracted from karaoke.blade.php (Phase 0). Blade-computed values arrive
   via window.KR_I18N (strings) and window.KR_ORT_URL (ONNX Runtime CDN url). */
document.addEventListener('DOMContentLoaded', function() {
(function() {
    // window.__perPixel / window.__setText (timbrica-core.js) write a position or a text only when what is
    // shown changes. A page built before they existed can still be handed this file — it then writes the
    // plain way. Why: docs/why/primitives/per-pixel-writes.md.
    function pxWrite(e, p, v, u) { if (window.__perPixel) return window.__perPixel(e, p, v, u); e.style[p] = v + (u || '%'); }
    function textWrite(e, t) { if (window.__setText) return window.__setText(e, t); e.textContent = t; }

    var LANG = window.KR_I18N || {};

    // ── State ──
    var originalBuffer = null;
    var musicBuffer = null;
    var fullMusicBuffer = null;
    var fullVocalBuffer = null;
    var audioCtx = null;
    var karaokeSource = null;
    var karaokeGain = null;
    /* The vocal guide is a MONITOR, as in any studio: the separated vocal plays
       through its own gain next to the backing. It is heard while you sing; it
       never enters the recording of your take (startRecording taps karaokeGain
       only); moving its slider is a gain change, not a re-render.
       Until 01.10.2026 the guide was baked INTO the backing (backing = song −
       (1 − guide)·vocal, default guide 10 %), so every downloaded minus, every
       karaoke video and every recorded performance carried the original singer
       at −20 dB — a level our recogniser still reads 46 of 130 words from
       (/vocal-remover, the same 90 % default, measured 01.10). Sept, RU: 89
       sessions downloaded a recording, 118 made a video, 115 downloaded the
       minus — all with the singer inside unless they found the slider. */
    var guideSource = null;
    var guideGain = null;
    var isPlaying = false;
    var startTime = 0;
    var pauseOffset = 0;
    var animFrame = null;
    var outputFormat = 'mp3';
    var outputQuality = '320';
    // The format picker is a <select> (#krFormatSelect); the channel module
    // still has to be told the format explicitly — same sweep as the other
    // 19 tools (2026-07-23). Without it the channel list ignored the format.
    if(window.ChannelModule) { ChannelModule.init('channelSelect', { tool: 'karaoke' }); ChannelModule.updateForFormat(outputFormat); }
    var inputExt = 'mp3';
    var processingMode = 'fast';
    // Off by default: karaoke means no lead vocal (the industry default too); the
    // guide is one move of its slider away for whoever wants a reference.
    var vocalGuide = 0;
    var currentKey = 0;
    var currentTempo = 1.0;
    var detectedBPM = 0;
    var fileName = '';

    /* ── Key / tempo: ONE processed buffer, played at rate 1.0 ────────────────
     * Key and tempo used to be applied live on the AudioBufferSourceNode as
     * `playbackRate = tempo` + `detune = key*100 - 1200*log2(tempo)`. Per the
     * Web Audio spec those combine into
     *     computedPlaybackRate = playbackRate * 2^(detune/1200)
     * so the tempo term cancelled itself exactly: the effective rate was
     * 2^(key/12), INDEPENDENT of tempo. Measured 2026-08-10 — tempo 150 % and
     * 50 % both rendered at rate 1.000, i.e. the tempo slider did nothing,
     * while every consumer still believed the rate was `currentTempo`:
     *
     *   · the lyric/cursor clock (`elapsed = wall * currentTempo`) drifted —
     *     50 % tempo ran the words at half speed against unchanged audio, and
     *     a +2 key silently played 12 % fast while the words kept 1.0×;
     *   · the total-time readout showed duration/tempo;
     *   · the video export sized its capture as duration/tempo, truncating the
     *     film to 67 % at 150 %;
     *   · the audio download did the same (now renderExportBuffer).
     *
     * The fix is to stop faking it. AudioPipeline.stretch (the shared
     * pitch-shift / time-stretch primitive, public/js/audio-pipeline.js) gives
     * genuinely independent axes: key changes pitch and leaves duration alone,
     * tempo changes duration and leaves pitch alone. We render ONCE per
     * (key, tempo) and play the result at rate 1.0 — so `elapsed` is plain wall
     * time and every consumer above is correct by construction, with no clock
     * conversion to get wrong. Measured cost on a 188 s song: ~2.0–2.7 s.
     *
     * Lyric timelines are authored against ORIGINAL song seconds, so when tempo
     * stretches the audio they are rescaled by 1/tempo into playback time —
     * see timelineInPlaybackTime(). */
    var processedBuffer = null;      // musicBuffer with key+tempo baked in
    var processedToken = null;       // token this buffer was rendered for
    var processedPending = null;     // in-flight render, so two slider releases share one
    /* Bumped whenever musicBuffer itself is replaced (a separation finishing).
       It rides in the cache token so a stale
       processed buffer — or a render still in flight over the OLD mix — can
       never be mistaken for the current one. */
    var musicBufferGen = 0;
    function shiftToken() { return musicBufferGen + ':' + currentKey + ':' + currentTempo; }
    function keyTempoIsIdentity() { return currentKey === 0 && currentTempo === 1.0; }

    /** The buffer that is actually playing right now (may lag a pending render). */
    function playbackBuffer() {
        if (keyTempoIsIdentity()) return musicBuffer;
        return (processedBuffer && processedToken === shiftToken()) ? processedBuffer : musicBuffer;
    }
    function playbackDuration() {
        var b = playbackBuffer();
        return b ? b.duration : 0;
    }

    /* Visible progress for the render. A 3-minute song is ~2 s on a laptop but
       can be 10–15 s on a phone, and a silent wait behind a disabled slider
       reads as a freeze. */
    function shiftStatus(show, pct) {
        var box = document.getElementById('krShiftStatus');
        var txt = document.getElementById('krShiftStatusText');
        if (!box) return;
        if (!show) { box.hidden = true; return; }
        if (txt) {
            txt.textContent = String(LANG.shift_applying || '')
                .replace(':pct', String(Math.max(0, Math.min(100, Math.round(pct || 0)))));
        }
        box.hidden = false;
    }
    function shiftProgress(p) {
        // AudioPipeline reports 0..1; some engines report 0..100.
        var pct = p > 1 ? p : p * 100;
        shiftStatus(true, pct);
    }

    /** Render (and cache) musicBuffer with the current key/tempo applied. */
    async function ensureProcessedBuffer() {
        if (!musicBuffer || keyTempoIsIdentity()) return musicBuffer;
        var token = shiftToken();
        if (processedBuffer && processedToken === token) return processedBuffer;
        if (processedPending && processedPending.token === token) return processedPending.promise;

        var promise = (async function () {
            if (!window.AudioPipeline || typeof window.AudioPipeline.stretch !== 'function') {
                // No shared primitive on the page — play the song untouched
                // rather than resurrect the broken resample.
                return musicBuffer;
            }
            var out = await window.AudioPipeline.stretch(musicBuffer, stretchOpts());
            return out || musicBuffer;
        })();
        processedPending = { token: token, promise: promise };
        try {
            var buf = await promise;
            if (processedPending && processedPending.token === token) {
                processedBuffer = buf;
                processedToken = token;
            }
            return buf;
        } finally {
            if (processedPending && processedPending.token === token) processedPending = null;
        }
    }
    // One stretch for every signal of the song (backing, guide, the exported
    // mix): same options ⇒ same engine ⇒ the guide stays where it was sung.
    // content:'music' — это песня (минусовка), классификатор не нужен.
    // interactive — человек ждёт, чтобы спеть: на песне 4 мин вокодер
    // тратил 11.8 с на смену тональности против 4.5 с у FFmpeg (лента +
    // WSOLA), а выигрывал лишь ~0.1 PQ (замер 30.09.2026) — берём FFmpeg.
    function stretchOpts() {
        return {
            semitones: currentKey,
            rate: currentTempo,
            content: 'music',
            interactive: true,
            slug: 'karaoke',
            onProgress: shiftProgress,
        };
    }

    /* ── Vocal guide (monitor) ────────────────────────────────────────────────
     * The separated vocal at the slider's level, on its own source and gain.
     * Rendered for key/tempo only while the guide is on — off by default, so
     * most sessions never pay for a second stretch. */
    var processedGuide = null, processedGuideToken = null, processedGuidePending = null;
    function guideLevel() { return Math.max(0, Math.min(1, vocalGuide / 100)); }
    function guideFitsTheSong() {
        // Index-for-index with the backing, or not at all: a vocal on other
        // clocks would play as a second, drifting singer (see buildBacking).
        return !!(fullVocalBuffer && musicBuffer && fullVocalBuffer.sampleRate === musicBuffer.sampleRate);
    }
    async function ensureProcessedGuide() {
        if (!guideFitsTheSong()) return null;
        if (keyTempoIsIdentity()) return fullVocalBuffer;
        var token = shiftToken();
        if (processedGuide && processedGuideToken === token) return processedGuide;
        if (processedGuidePending && processedGuidePending.token === token) return processedGuidePending.promise;
        var promise = (async function () {
            if (!window.AudioPipeline || typeof window.AudioPipeline.stretch !== 'function') return null;
            return (await window.AudioPipeline.stretch(fullVocalBuffer, stretchOpts())) || null;
        })();
        processedGuidePending = { token: token, promise: promise };
        try {
            var buf = await promise;
            if (processedGuidePending && processedGuidePending.token === token) {
                processedGuide = buf;
                processedGuideToken = token;
            }
            return buf;
        } finally {
            if (processedGuidePending && processedGuidePending.token === token) processedGuidePending = null;
        }
    }
    /** The guide buffer to play right now, or null (off, not rendered yet, no vocal). */
    function guidePlaybackBuffer() {
        if (vocalGuide <= 0 || !guideFitsTheSong()) return null;
        if (keyTempoIsIdentity()) return fullVocalBuffer;
        return (processedGuide && processedGuideToken === shiftToken()) ? processedGuide : null;
    }
    // Speakers only — never karaokeGain's path into the recording.
    function startGuide(when, offset) {
        stopGuide();
        var gb = guidePlaybackBuffer();
        if (!gb || !audioCtx || offset >= gb.duration) return;
        guideSource = audioCtx.createBufferSource();
        guideSource.buffer = gb;
        guideGain = audioCtx.createGain();
        guideGain.gain.value = guideLevel();
        guideSource.connect(guideGain);
        guideGain.connect(audioCtx.destination);
        guideSource.start(when, Math.max(0, offset));
    }
    function stopGuide() {
        if (guideSource) { try { guideSource.stop(); } catch (e) {} }
        guideSource = null;
        guideGain = null;
    }

    /* What the downloaded minus and the karaoke video carry: the backing, plus
       the guide at the level the slider shows — it is what the person listened
       to, and at 100 % it is how /karaoke transposes the whole song. Mixed
       BEFORE the stretch and stretched once, so nothing can drift. */
    async function renderExportBuffer() {
        var g = guideLevel();
        if (g <= 0 || !guideFitsTheSong()) return (await ensureProcessedBuffer()) || musicBuffer;
        var n = Math.min(musicBuffer.length, fullVocalBuffer.length);
        var mixed = window.__safeAudioBuffer({ length: n, numberOfChannels: 2, sampleRate: musicBuffer.sampleRate });
        for (var ch = 0; ch < 2; ch++) {
            var b = musicBuffer.getChannelData(Math.min(ch, musicBuffer.numberOfChannels - 1));
            var v = fullVocalBuffer.getChannelData(Math.min(ch, fullVocalBuffer.numberOfChannels - 1));
            var o = mixed.getChannelData(ch);
            for (var i = 0; i < n; i++) o[i] = b[i] + g * v[i];
        }
        if (keyTempoIsIdentity() || !window.AudioPipeline || typeof window.AudioPipeline.stretch !== 'function') return mixed;
        try {
            return (await window.AudioPipeline.stretch(mixed, stretchOpts())) || mixed;
        } finally {
            shiftStatus(false);
        }
    }

    /* ── The one clock boundary ───────────────────────────────────────────────
     * CONVENTION: every lyric timeline stays in ORIGINAL song seconds — that is
     * what the user's .lrc file says and what the sync editor writes. Playback
     * time differs only by tempo (key no longer stretches anything), so these
     * two functions are the ONLY place the two bases meet. Anything that
     * compares a clock against a timeline goes through them. */
    function toSongTime(playbackSec) { return playbackSec * currentTempo; }
    function toPlaybackTime(songSec) { return songSec / currentTempo; }

    /* Lyric timeline mapped from ORIGINAL song seconds into playback seconds.
       Used ONLY by the video export, whose burned-in progress bar and timecode
       must agree with the exported file's own duration. Cached — the export
       asks per frame. */
    var tlCacheToken = null, tlCacheSrc = null, tlCacheOut = null;
    function timelineInPlaybackTime() {
        var tl = activeTimeline();
        if (currentTempo === 1.0 || !tl.length) return tl;
        var token = currentTempo + ':' + tl.length;
        if (tlCacheOut && tlCacheToken === token && tlCacheSrc === tl) return tlCacheOut;
        var k = 1 / currentTempo;
        tlCacheOut = tl.map(function (l) {
            return {
                startS: l.startS == null ? l.startS : l.startS * k,
                endS: l.endS == null ? l.endS : l.endS * k,
                text: l.text,
                words: l.words ? l.words.map(function (w) {
                    return { startS: w.startS * k, text: w.text };
                }) : null,
            };
        });
        tlCacheToken = token;
        tlCacheSrc = tl;
        return tlCacheOut;
    }

    // Mic state
    var micStream = null, micSource = null, micGain = null, micAnalyser = null;
    // micBus — the mic AFTER volume and reverb, the one signal both the
    // recording and the monitor take. The way from it to the speakers is
    // owned by MicMonitor (default OFF, shared preference, headphones hint);
    // until 2026-09-23 the mic went to the speakers ALWAYS, with no switch.
    var micBus = null, micMonitor = null;
    var $monitorSlot = document.getElementById('krMonitorSlot');
    function monitorLabels() {
        return { label: LANG.monitor_label, hint: LANG.monitor_hint, on: LANG.monitor_on, off: LANG.monitor_off };
    }
    if (window.MicMonitor && $monitorSlot) {
        try { MicMonitor.control({ tool: 'karaoke', mount: $monitorSlot, hintMount: $monitorSlot.parentNode, labels: monitorLabels() }); } catch (e) {}
    }
    var reverbNode = null, reverbWetGain = null, reverbDryGain = null;
    var echoDelay = null, echoFeedback = null;
    var micEnabled = false, currentReverb = 'off', irBuffers = {};
    var micMeterFrame = null;

    // Recording state
    var mediaRecorder = null, recordChunks = [], recordBlob = null, recordName = '';
    var isRecording = false, recordStartTime = 0, recordTimerInterval = null, mixDestination = null;
    // Latency compensation for the mixed recording (owner: RecordingLatency,
    // public/js/recording-latency.js + the shared recording-sync row). The
    // mic reaches the graph (output + input latency) AFTER the backing the
    // singer heard, so the backing's copy INTO the recording goes through a
    // DelayNode of that length; what plays to the speakers is untouched.
    // Before 2026-09-22 the mix was recorded raw and the voice sat 60–230 ms
    // behind the music in every karaoke recording.
    var mixDelay = null, recLatencyMs = 0, recLatencyKind = 'none', recSync = null;
    function backingMixTarget() {
        if (!mixDestination) return null;
        if (!mixDelay) {
            try {
                if (window.RecordingLatency && micStream && audioCtx) {
                    var r = RecordingLatency.resolve(audioCtx, micStream);
                    recLatencyMs = r.ms; recLatencyKind = r.kind;
                }
            } catch (e) {}
            mixDelay = audioCtx.createDelay(2);
            mixDelay.delayTime.value = Math.min(1.5, Math.max(0, recLatencyMs) / 1000);
            mixDelay.connect(mixDestination);
        }
        return mixDelay;
    }
    function bindRecSync() {
        var row = document.getElementById('recSyncRow');
        if (!row || !window.RecordingLatency || recSync) return;
        recSync = RecordingLatency.bindRow(row, {
            slug: 'karaoke',
            getCtx: function () {
                if (!audioCtx || audioCtx.state === 'closed') audioCtx = new (window.AudioContext || window.webkitAudioContext)();
                return audioCtx;
            },
            getMicStream: function () { return micStream; },
            acquireMic: function () {
                if (!window._krMic) window._krMic = new MicManager({ slug: 'karaoke' });
                return window._krMic.startRaw({ audio: { echoCancellation: false, noiseSuppression: false, autoGainControl: false } });
            },
            releaseMic: function () { try { window._krMic.stop(); } catch (e) {} },
            isBusy: function () { return isRecording; },
            onChange: function (ms, kind) {
                recLatencyMs = ms; recLatencyKind = kind;
                if (mixDelay) mixDelay.delayTime.value = Math.min(1.5, ms / 1000);
            }
        });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindRecSync);
    else bindRecSync();
    window.__krDebug = function () {
        return {
            micEnabled: micEnabled, micBus: !!micBus, monitor: micMonitor ? micMonitor.enabled : null,
            isRecording: isRecording, recLatencyMs: recLatencyMs, recLatencyKind: recLatencyKind,
            reverb: currentReverb, mixDelayS: mixDelay ? mixDelay.delayTime.value : null,
            guide: vocalGuide, guidePlaying: !!guideSource, guideGain: guideGain ? guideGain.gain.value : null,
        };
    };

    // LRC state
    var lrcLines = [], lrcActive = false, lrcCurrentIndex = -1, lyricsMode = 'plain';

    // Loop state
    var loopA = null, loopB = null, loopEnabled = false;

    // ── DOM ──
    var $upload = document.getElementById('krUpload');
    var $processing = document.getElementById('krProcessing');
    var $procStep = document.getElementById('krProcStep');
    var $procSub = document.getElementById('krProcSub');
    var $procFill = document.getElementById('krProcFill');
    var $error = document.getElementById('krError');
    var $result = document.getElementById('krResult');
    var $fileName = document.getElementById('krFileName');
    var $key = document.getElementById('krKey');
    var $bpm = document.getElementById('krBpm');
    var $monoWarn = document.getElementById('krMonoWarn');
    var $canvas = document.getElementById('krCanvas');
    var $cursor = document.getElementById('krCursor');
    var $playBtn = document.getElementById('krPlayBtn');
    var $timeCur = document.getElementById('krTimeCur');
    var $timeTot = document.getElementById('krTimeTot');
    var $guideSlider = document.getElementById('krGuide');
    var $guideVal = document.getElementById('krGuideVal');
    // The slider is the one truth for the guide level (and its label agrees).
    if ($guideSlider) {
        vocalGuide = Math.max(0, Math.min(100, parseInt($guideSlider.value, 10) || 0));
        if ($guideVal) $guideVal.textContent = vocalGuide + '%';
    }
    var $keySlider = document.getElementById('krKeySlider');
    var $keyVal = document.getElementById('krKeyVal');
    var $tempoSlider = document.getElementById('krTempoSlider');
    var $tempoVal = document.getElementById('krTempoVal');
    var $lyricsText = document.getElementById('krLyricsText');
    var $download = document.getElementById('krDownload');
    var $newBtn = document.getElementById('krNewBtn');
    var $stopBtn = document.getElementById('krStopBtn');
    var $sourceBadge = document.getElementById('krSourceBadge');
    var $qualitySel = document.getElementById('krQualitySel');        // field wrapper — hidden for lossless
    var $formatSelect = document.getElementById('krFormatSelect');
    var $qualitySelect = document.getElementById('krQualitySelect');
    var $lyricsKaraoke = document.getElementById('krLyricsKaraoke');
    var $lyricsEditBtn = document.getElementById('krLyricsEditBtn');
    // Saved songs / key fit / session score
    var $songs = document.getElementById('krSongs');
    var $songsList = document.getElementById('krSongsList');
    var $saveSong = document.getElementById('krSaveSong');
    var $fit = document.getElementById('krFit');
    var $fitText = document.getElementById('krFitText');
    var $fitApply = document.getElementById('krFitApply');
    var $session = document.getElementById('krSession');
    var $sessionGrade = document.getElementById('krSessionGrade');
    var $sessionLine = document.getElementById('krSessionLine');
    var $sessionShare = document.getElementById('krSessionShare');
    var guideTimeout, keyTempoTimeout, tempoTelemetryTimeout;

    // Mic DOM
    var $mic = document.getElementById('krMic');
    var $micToggle = document.getElementById('krMicToggle');
    var $micVol = document.getElementById('krMicVol');
    var $micMeter = document.getElementById('krMicMeter');
    var $reverbBtns = document.getElementById('krReverbBtns');

    // Rec DOM
    var $recBtn = document.getElementById('krRecBtn');
    var $recTimer = document.getElementById('krRecTimer');
    var $recDl = document.getElementById('krRecDl');

    // LRC DOM
    var $lrcFile = document.getElementById('krLrcFile');
    var $lrcPaste = document.getElementById('krLrcPaste');
    var $lrcStatus = document.getElementById('krLrcStatus');
    var $lrcDisplay = document.getElementById('krLrcDisplay');

    // Loop DOM
    var $loopA = document.getElementById('krLoopA');
    var $loopB = document.getElementById('krLoopB');
    var $loopClear = document.getElementById('krLoopClear');
    var $loopBadge = document.getElementById('krLoopBadge');
    var $loopRegion = document.getElementById('krLoopRegion');
    var $loopMarkerA = document.getElementById('krLoopMarkerA');
    var $loopMarkerB = document.getElementById('krLoopMarkerB');

    // ── Mode selector ──
    var $modeHint = document.getElementById('krModeHint');
    var $guidePanel = document.getElementById('krGuidePanel');
    function modeHintText(mode) {
        if (mode === 'ultra') return LANG.mode_ultra_hint || '';
        if (mode === 'ai') return LANG.mode_ai_hint || '';
        if (mode === 'instrumental') return LANG.mode_instrumental_hint || '';
        return '';
    }

    // ── Какой режим ставить по умолчанию ──────────────────────────────
    //
    // Замерено на MUSDB18 (50 треков, окна 60 с из середины):
    //   Ultra (Kim_Vocal_2)  подавление вокала 17.66 дБ, порча музыки 0.08
    //   Fast  (вычитание центра)             10.77 дБ,              1.48
    // Но Ultra считает трёхминутную песню за 1–2 минуты НА ВИДЕОКАРТЕ и за
    // 28.7 минуты в один поток WASM, поэтому дефолт зависит от неё.
    //
    // ⚠️ Признак — УСТРОЙСТВО WebGPU, а не адаптер. requestAdapter() возвращает
    // объект и там, где requestDevice() падает (нет dxil.dll, драйвер в
    // blocklist, виртуалка), а ORT в этом случае молча уходит на wasm. На этом
    // различии 14.08 сломался измерительный стенд и родился ложный вывод
    // «видеокарта не помогает».
    var modeChosenByUser = false;
    var applyingDefaultMode = false;

    function applyGpuDefaultMode() {
        // Вызывается ТОЛЬКО по вердикту общего модуля (см. ниже) — сам
        // ничего не решает: вторая копия политики на этой странице уже
        // стоила 89.5% потерянных мобильных сессий соседнему тулу.
        if (modeChosenByUser) return;
        if (!window.MdxStemSeparator) return;          // модуль не поднялся
        var btn = document.querySelector('.kr-mode-btn[data-mode="ultra"]');
        if (!btn || btn.classList.contains('active')) return;
        applyingDefaultMode = true;
        try { btn.click(); } finally { applyingDefaultMode = false; }
        if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'default_mode_ultra', reason: 'webgpu_device' });
    }

    (function resolveDefaultEngine(){
        // Политика «включать ли Ультра сама» — в ОБЩЕМ модуле
        // (mdx-stem-separator.js, defaultEngineVerdict): один и тот же
        // вердикт для /vocal-remover и /karaoke. До 19.08 здесь была своя
        // копия пробы «создаётся ли WebGPU-устройство» — и та же ошибка:
        // устройство ≠ скорость (замер 15–18.08: 78% телефонов имеют
        // устройство, завершаемость авто-Ультры там 12.7% против фона 49.3%).
        var tries = 0;
        (function wait(){
            var M = window.MdxStemSeparator;
            if (!M || typeof M.defaultEngineVerdict !== 'function') {
                if (++tries > 100) return;   // модуль не поднялся — остаёмся на Быстро
                return setTimeout(wait, 100);
            }
            M.defaultEngineVerdict().then(function(v){
                if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'default_engine_verdict', ultra: v.ultra ? 1 : 0, reason: v.reason, rate: v.rate || 0 });
                if (v.ultra) { try { applyGpuDefaultMode(); } catch(_) {} }
            }, function(){});
        })();
    })();

    document.querySelectorAll('.kr-mode-btn').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault(); e.stopPropagation();
            // Ручной выбор запоминаем, чтобы автоопределение видеокарты его не
            // перебило. Синтетический клик из applyGpuDefaultMode ручным не
            // считается.
            if (!applyingDefaultMode) modeChosenByUser = true;
            document.querySelectorAll('.kr-mode-btn').forEach(function(b) { b.classList.remove('active'); });
            btn.classList.add('active');
            processingMode = btn.dataset.mode;
            $modeHint.textContent = modeHintText(processingMode);
            // Which engine people actually pick, and specifically how many
            // arrive with a backing track already in hand ("instrumental").
            if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'mode_select', mode: processingMode });
        });
    });

    // ── Upload (drag/drop/click owned by shared uploader component) ──
    $upload.addEventListener('tool-uploader:file', function(e) {
        var f = e.detail && e.detail.file;
        if (f) processFile(f);
    });

    // ── Lyrics plain text persistence (per song) ──
    // A global bind clobbers lyrics when the user switches songs. Instead we key
    // saved lyrics by file name + size so each track keeps its own words.
    var songKey = null;
    function songLyricsKey(file) { return 'lyrics_' + file.name + '_' + file.size; }
    var lyricsFromStorage = false;    // the sheet holds this file's saved words, not new ones
    function loadSongLyrics() {
        if (!window.__toolSettings || !songKey) return;
        $lyricsText.value = window.__toolSettings.load('karaoke', songKey, '') || '';
        lyricsFromStorage = !!$lyricsText.value.trim();
    }
    function saveSongLyrics() {
        if (window.__toolSettings && songKey) {
            window.__toolSettings.save('karaoke', songKey, $lyricsText.value);
        }
    }

    /* ── Pasted words and the song ────────────────────────────────────────────
     * Pasted lyrics carry no times. Until 2026-09-18 this block INVENTED them —
     * KaraokeLyrics.fromPlainText divides the file's duration by the number of
     * lines — and then lit, scrolled, counted-in and burned them into the video
     * exactly like a real synced file. Measured on songs with human line
     * annotations the median line sat 10–26 s from where it is sung; feedback
     * #1704 (a vocalist): «не совпадает с мелодией, не попадает в ритм».
     *
     * A timeline in plainLrcLines is now ALWAYS real: placed on the voice by
     * KaraokeAutoSync (forced alignment over the vocal stem), tapped by the
     * user, or restored from one of those two for exactly this text. Until one
     * exists the words stay what they are — a sheet to read — and the page says
     * so (the #krAutoSync block) instead of pretending.
     *
     * plainLrcLines is a {startS, endS, text, words?} timeline. */
    var plainLrcLines = [];
    var plainLrcActive = false;
    var plainSyncSrc = '';            // 'auto' | 'tap' — who placed the current timeline
    var plainSyncedText = '';         // the exact text that timeline belongs to

    function plainLines() {
        return $lyricsText.value.split(/\r?\n/)
            .map(function (l) { return l.trim(); })
            .filter(function (l) { return l; });
    }
    function plainTextKey() { return plainLines().join('\n'); }

    /* The placed timeline outlives a reload the same way the words do: next to
       them, per file. Stored as Enhanced LRC — the format the page already
       reads and writes — together with the text it was made for, because a
       timeline for yesterday's wording is a wrong timeline. */
    function saveSyncedTimeline() {
        if (!window.__toolSettings || !songKey || !window.KaraokeLyrics) return;
        var payload = plainLrcLines.length
            ? JSON.stringify({ t: plainSyncedText, src: plainSyncSrc, lrc: window.KaraokeLyrics.serializeLRC(plainLrcLines) })
            : '';
        try { window.__toolSettings.save('karaoke', songKey + '_sync', payload); } catch (_) {}
    }
    function loadSyncedTimeline() {
        if (!window.__toolSettings || !songKey || !window.KaraokeLyrics) return null;
        try {
            var raw = window.__toolSettings.load('karaoke', songKey + '_sync', '');
            if (!raw) return null;
            var o = JSON.parse(raw);
            if (!o || o.t !== plainTextKey()) return null;
            var lines = window.KaraokeLyrics.parseLRC(o.lrc).lines;
            return lines.length ? { lines: lines, src: o.src === 'tap' ? 'tap' : 'auto' } : null;
        } catch (_) { return null; }
    }

    /* ── The song's voice is still being separated ──────────────────────────
     * Since 30.09.2026 the workspace opens at the file pick, not after the
     * separation (1–10 minutes on a real laptop; RU 30 d, desktops with ≤ 4 GB
     * and ≤ 4 cores separate at 2.1× the song's length). Until then the page
     * showed a spinner and nothing else, while the how-to and the FAQ said
     * «paste the words and press "Place on the voice"» — #8273 read the FAQ a
     * minute into that wait and wrote «не могу создать караоке с текстом».
     * Now the words go in at once, and «Place on the voice» can be pressed
     * during the separation: the model downloads meanwhile, the words are
     * placed the moment the voice is there. */
    var songPending = false;          // a file is in; its voice is not separated yet
    var decodedP = null;              // resolves once originalBuffer is decoded (its length is known)
    var curProcToken = null;          // processFile() of the file on screen — a newer pick retires older runs

    /** Called whenever the words or the track change: decide what is TRUE now. */
    function refreshPlainLyrics() {
        if (!window.KaraokeLyrics) return;
        // A placement that is queued or running owns the block until it ends.
        if (autoSyncRunning || asQueued) return;
        updateFindLrcButton();
        var key = plainTextKey();
        if (!key || (!musicBuffer && !songPending)) {
            plainLrcLines = []; plainSyncSrc = ''; plainSyncedText = '';
            hidePlainKaraoke();
            setSyncFace(null);
            return;
        }
        if (plainLrcLines.length && plainSyncedText === key) {      // still the same words
            renderPlainKaraoke();
            setSyncFace('synced');
            return;
        }
        var saved = loadSyncedTimeline();
        if (saved) {
            plainLrcLines = saved.lines; plainSyncSrc = saved.src; plainSyncedText = key;
            renderPlainKaraoke();
            setSyncFace('synced');
            if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'lyrics_ready', src: 'restored', lines: plainLrcLines.length });
            return;
        }
        var hadTimeline = plainLrcLines.length > 0;
        plainLrcLines = []; plainSyncSrc = ''; plainSyncedText = '';
        hidePlainKaraoke();
        setSyncFace('untimed', hadTimeline ? { note: LANG.as_edited, tone: 'warn' }
            : (songPending ? { note: LANG.as_pending_note } : null));
        if (!untimedReported) {
            untimedReported = true;
            // The path nobody could see: 116 of 170 video-export sessions a month
            // had no timed source at all, and nothing said how many of them had words.
            // `during` — the words went in while the voice was still being split,
            // the wait that used to have no place for them (#8273).
            if (window.__ae) window.__ae('feature_use', {
                slug: 'karaoke', f: 'lyrics_pasted', lines: plainLines().length,
                during: songPending ? 1 : 0, restored: lyricsFromStorage ? 1 : 0,
            });
        }
    }
    var untimedReported = false;

    /** Adopt a REAL timeline (from the aligner or the tap editor). */
    function adoptPlainTimeline(tl, src) {
        plainLrcLines = tl; plainSyncSrc = src; plainSyncedText = plainTextKey();
        saveSyncedTimeline();
        renderPlainKaraoke();
        setSyncFace('synced');
    }

    function renderPlainKaraoke() {
        window.KaraokeLyrics.render($lyricsKaraoke, plainLrcLines, { onSeek: seekToTime });
        plainLrcActive = true;
        $lyricsText.classList.add('hidden');
        $lyricsKaraoke.classList.add('active');
        $lyricsEditBtn.classList.add('active');
        refreshSyncOpenBtn();
    }

    function hidePlainKaraoke() {
        plainLrcActive = false;
        $lyricsKaraoke.classList.remove('active');
        $lyricsKaraoke.innerHTML = '';
        $lyricsEditBtn.classList.remove('active');
        $lyricsText.classList.remove('hidden');
        refreshSyncOpenBtn();
    }

    function updatePlainLyricsHighlight(currentTime) {
        if (!plainLrcActive || plainLrcLines.length === 0 || !window.KaraokeLyrics) return;
        window.KaraokeLyrics.update($lyricsKaraoke, plainLrcLines, currentTime);
    }

    $lyricsText.addEventListener('input', function() {
        lyricsFromStorage = false;
        saveSongLyrics();
        refreshSyncOpenBtn();
        updateFindLrcButton();
        clearTimeout(guideTimeout);
        guideTimeout = setTimeout(refreshPlainLyrics, 500);
    });

    $lyricsEditBtn.addEventListener('click', function() {
        // Opening the words for editing does not throw the timing away: it goes
        // only if the words actually change (refreshPlainLyrics compares them).
        hidePlainKaraoke();
        setSyncFace(null);
        $lyricsText.focus();
    });
    $lyricsText.addEventListener('blur', function () {
        if (!syncEditorOpen && !autoSyncRunning) refreshPlainLyrics();
    });

    // ═══════════════════════════════════════
    // Words on the voice — KaraokeAutoSync
    // ═══════════════════════════════════════
    var $as = document.getElementById('krAutoSync');
    var $asStart = document.getElementById('krAsStart');
    var $asConsentText = document.getElementById('krAsConsentText');
    var $asConsentGo = document.getElementById('krAsConsentGo');
    var $asConsentCancel = document.getElementById('krAsConsentCancel');
    var $asStage = document.getElementById('krAsStage');
    var $asFill = document.getElementById('krAsFill');
    var $asAbort = document.getElementById('krAsAbort');
    var $asSyncedText = document.getElementById('krAsSyncedText');
    var $asLrc = document.getElementById('krAsLrc');
    var $asNote = document.getElementById('krAsNote');
    var autoSyncRunning = false, autoSyncAbort = null;
    // Agreed to while the voice was still being separated: { plan, est, cached, at }.
    // The model downloads meanwhile (asPrefetchP); the words are placed when the
    // separation ends (startQueuedAutoSync).
    var asQueued = null, asPrefetchP = null, asPrefetchAbort = null;
    // Which engine made the stem. Only Kim's is clean enough to gate on and to
    // tell a backing track from a song; centre-cut and CascadedNet "vocals" carry
    // the snare and the bass, so with them the aligner hears the mix and no gate.
    var stemEngine = '';

    function setSyncFace(face, opts) {
        if (!$as) return;
        opts = opts || {};
        if (!face) { $as.hidden = true; return; }
        $as.hidden = false;
        $as.dataset.state = face;
        $as.dataset.tone = opts.tone || '';
        var parts = $as.querySelectorAll('[data-face]');
        for (var i = 0; i < parts.length; i++) parts[i].hidden = parts[i].dataset.face !== face;
        if ($asNote) $asNote.textContent = opts.note || '';
        if (face === 'synced' && $asSyncedText) {
            var tpl = (plainSyncSrc === 'tap' ? LANG.as_done_tap : LANG.as_done_auto) || '';
            $asSyncedText.innerHTML = '<b>' + escapeHtml(tpl.replace(':count', plainLrcLines.length)) + '</b>';
        }
    }
    function escapeHtml(s) {
        return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
    }
    function asProgress(pct, label) {
        if ($asFill) $asFill.style.width = Math.max(0, Math.min(100, pct)) + '%';
        if ($asStage && label != null) $asStage.textContent = label;
    }
    function fmtEta(sec) {
        return sec >= 90 ? Math.round(sec / 60) + ' ' + (LANG.as_unit_min || 'min') : Math.max(5, Math.round(sec / 5) * 5) + ' ' + (LANG.as_unit_sec || 's');
    }

    function autoSyncRefusal(code, extra) {
        var map = {
            'no-vocals': LANG.as_err_no_vocals, 'script-unsupported': LANG.as_err_script,
            'too-long': LANG.as_err_too_long, 'aborted': LANG.as_cancelled,
        };
        return map[code] || LANG.as_err_failed || '';
    }

    if ($asStart) $asStart.addEventListener('click', function () {
        if (autoSyncRunning || asQueued || !window.KaraokeAutoSync) return;
        var lines = plainLines();
        if (!lines.length || (!musicBuffer && !songPending)) return;
        var AS = window.KaraokeAutoSync;
        // A backing-track upload has no voice to place words on — say it before
        // offering a download that cannot help. (While the voice is still being
        // separated the stem does not exist YET; that is not a backing track.)
        if (processingMode === 'instrumental' || (!songPending && !fullVocalBuffer)) {
            setSyncFace('untimed', { note: LANG.as_err_instrumental, tone: 'warn' });
            if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'autosync_refused', reason: 'instrumental' });
            return;
        }
        // Same hint the run uses, so the offer and the run agree on the language.
        var plan = AS.planFor(lines.join('\n'), window.__LOCALE);
        if (!plan.provider) {
            setSyncFace('untimed', { note: autoSyncRefusal(plan.reason), tone: 'warn' });
            if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'autosync_refused', reason: plan.reason, script: plan.script });
            return;
        }
        // The length decides the estimate; a file picked a second ago may still
        // be decoding (a few seconds at most).
        (decodedP || Promise.resolve()).then(function () {
            if (!originalBuffer) return;                 // it did not decode — that error is on screen
            if (originalBuffer.duration > 15 * 60) {
                setSyncFace('untimed', { note: LANG.as_err_too_long, tone: 'warn' });
                if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'autosync_refused', reason: 'too-long' });
                return;
            }
            var gpu = false, est = null;
            return (plan.provider === 'phon' ? AS.gpuUsable() : Promise.resolve(false)).then(function (g) {
                gpu = g;
                est = AS.estimate(plan.provider, originalBuffer.duration, gpu);
                return AS.modelCached(plan.provider, gpu);
            }).then(function (cached) {
                if (window.__ae) window.__ae('feature_use', {
                    slug: 'karaoke', f: 'autosync_offer', provider: plan.provider, cached: cached ? 1 : 0,
                    gpu: gpu ? 1 : 0, lines: lines.length, durS: Math.round(originalBuffer.duration),
                    pending: songPending ? 1 : 0,
                });
                // Pressed while the voice is still being split: the model is fetched
                // now, the words are placed when the voice is ready. Otherwise — now.
                var go = function () { if (songPending) queueAutoSync(plan, est, cached); else runAutoSync(plan, est, cached); };
                // Cached and quick: nothing to agree to, so do not ask.
                if (cached && est.seconds <= 180) { go(); return; }
                var tpl = (est.seconds > 180 ? LANG.as_consent_slow : LANG.as_consent) || '';
                $asConsentText.textContent = tpl
                    .replace(':mb', cached ? '0' : String(est.downloadMB))
                    .replace(':time', fmtEta(est.seconds));
                $asConsentGo.onclick = go;
                setSyncFace('consent');
            });
        });
    });
    if ($asConsentCancel) $asConsentCancel.addEventListener('click', function () { refreshPlainLyrics(); });
    if ($asAbort) $asAbort.addEventListener('click', function () {
        if (asQueued) { cancelQueuedAutoSync(false); return; }
        if (autoSyncAbort) { try { autoSyncAbort.abort(); } catch (_) {} }
    });

    /* Agreed to during the separation. The model's download starts NOW and runs
       beside the separation (the two used to queue: separation, then the button,
       then the 305 MB); the placing itself needs the voice and waits for it. */
    function queueAutoSync(plan, est, cached) {
        if (asQueued || autoSyncRunning) return;
        var q = asQueued = { plan: plan, est: est, cached: cached, at: Date.now() };
        setSyncFace('running');
        asProgress(2, LANG.as_stage_wait_voice || '');
        if (window.__ae) window.__ae('feature_use', {
            slug: 'karaoke', f: 'autosync_queued', provider: plan.provider, cached: cached ? 1 : 0,
            durS: originalBuffer ? Math.round(originalBuffer.duration) : 0,
        });
        if (cached) { asPrefetchP = Promise.resolve({ skipped: true }); return; }
        asPrefetchAbort = (typeof AbortController !== 'undefined') ? new AbortController() : null;
        var t0 = Date.now();
        asPrefetchP = window.KaraokeAutoSync.prefetch(plan.provider, {
            signal: asPrefetchAbort ? asPrefetchAbort.signal : null,
            onProgress: function (p) {
                if (asQueued !== q || !p || p.phase !== 'download' || !p.total) return;
                var pct = Math.round(100 * p.loaded / p.total);
                asProgress(5 + pct * 0.45, (LANG.as_stage_download || '').replace(':pct', pct));
            },
        });
        asPrefetchP.then(function (r) {
            if (r && !r.skipped && window.__ae) window.__ae('feature_use', {
                slug: 'karaoke', f: 'autosync_prefetch_done', provider: plan.provider, secs: Math.round((Date.now() - t0) / 1000),
            });
            if (asQueued === q && songPending) asProgress(50, LANG.as_stage_wait_voice || '');
        }, function (err) {
            var code = (err && err.code) || 'failed';
            if (asQueued !== q) return;               // cancelled by the person or by a new file
            asQueued = null; asPrefetchAbort = null; asPrefetchP = null;
            refreshPlainLyrics();
            setSyncFace('untimed', { note: autoSyncRefusal(code), tone: 'err' });
            if (window.__ae) window.__ae('feature_use', {
                slug: 'karaoke', f: 'autosync_failed', reason: code, queued: 1, provider: plan.provider,
                detail: String((err && err.detail) || '').slice(0, 120), secs: Math.round((Date.now() - t0) / 1000),
            });
        });
    }

    /** The separation ended: place the words agreed to during it. */
    function startQueuedAutoSync() {
        var q = asQueued;
        if (!q) return;
        (asPrefetchP || Promise.resolve()).then(function () {
            if (asQueued !== q) return;               // cancelled meanwhile, or the download failed
            asQueued = null; asPrefetchAbort = null; asPrefetchP = null;
            if (!plainLines().length) { refreshPlainLyrics(); return; }
            if (processingMode === 'instrumental' || !fullVocalBuffer) {
                refreshPlainLyrics();
                setSyncFace('untimed', { note: LANG.as_err_instrumental, tone: 'warn' });
                return;
            }
            runAutoSync(q.plan, q.est, true, { queuedAt: q.at });
        }, function () { /* the queue's own handler has already said why */ });
    }

    /** Person pressed «Cancel», or a new file replaced this one. */
    function cancelQueuedAutoSync(silent) {
        if (!asQueued) return;
        var q = asQueued;
        asQueued = null;
        if (asPrefetchAbort) { try { asPrefetchAbort.abort(); } catch (_) {} }
        asPrefetchAbort = null; asPrefetchP = null;
        if (window.__ae) window.__ae('feature_use', {
            slug: 'karaoke', f: 'autosync_cancelled', reason: 'aborted', queued: 1, provider: q.plan.provider,
            secs: Math.round((Date.now() - q.at) / 1000),
        });
        if (!silent) { refreshPlainLyrics(); setSyncFace('untimed', { note: LANG.as_cancelled }); }
    }

    function runAutoSync(plan, est, cached, extra) {
        if (autoSyncRunning) return;
        var AS = window.KaraokeAutoSync, lines = plainLines();
        // The words this timeline is FOR: an edit during the run makes it someone
        // else's timeline, and adopting it would light the new words at old times.
        var textAtStart = plainTextKey();
        autoSyncRunning = true;
        autoSyncAbort = (typeof AbortController !== 'undefined') ? new AbortController() : null;
        setSyncFace('running');
        asProgress(2, LANG.as_stage_prepare || '');
        var t0 = Date.now(), device = '';
        if (window.__ae) window.__ae('feature_use', {
            slug: 'karaoke', f: 'autosync_start', provider: plan.provider, cached: cached ? 1 : 0,
            lines: lines.length, durS: Math.round(originalBuffer.duration), engine: stemEngine,
            // queued: agreed to during the separation; waitedS — from that press to here.
            queued: extra && extra.queuedAt ? 1 : 0,
            waitedS: extra && extra.queuedAt ? Math.round((Date.now() - extra.queuedAt) / 1000) : 0,
        });
        // Kim's stem is the one the gate and the no-vocals test were measured on.
        var clean = stemEngine === 'kim';
        AS.run({
            lines: lines,
            vocalBuffer: clean ? fullVocalBuffer : originalBuffer,
            mixBuffer: originalBuffer,
            trustStem: clean,
            durationS: originalBuffer.duration,
            signal: autoSyncAbort ? autoSyncAbort.signal : null,
            onProgress: function (p) {
                if (!p) return;
                if (p.phase === 'download' && p.total) {
                    var pct = Math.round(100 * p.loaded / p.total);
                    asProgress(5 + pct * 0.45, (LANG.as_stage_download || '').replace(':pct', pct));
                } else if (p.phase === 'session') {
                    asProgress(52, LANG.as_stage_session || '');
                } else if (p.phase === 'ready') {
                    device = p.device || '';
                    // The fast lane was refused or absent: the promise made a moment
                    // ago ("about 15 s") is no longer true, so replace it.
                    if (plan.provider === 'phon' && device === 'wasm' && est.gpu) {
                        var slow = AS.estimate('phon', originalBuffer.duration, false);
                        if ($asNote) $asNote.textContent = (LANG.as_slow_lane || '').replace(':time', fmtEta(slow.seconds));
                    }
                } else if (p.phase === 'align' && p.total) {
                    asProgress(55 + 43 * (p.loaded / p.total),
                        (LANG.as_stage_align || '').replace(':done', p.loaded).replace(':total', p.total));
                }
            },
        }).then(function (res) {
            autoSyncRunning = false; autoSyncAbort = null;
            if (plainTextKey() !== textAtStart) {
                refreshPlainLyrics();
                setSyncFace('untimed', { note: LANG.as_edited, tone: 'warn' });
                if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'autosync_text_changed', provider: res.provider });
                return;
            }
            adoptPlainTimeline(res.timeline, 'auto');
            if (res.mismatch) setSyncFace('synced', { note: LANG.as_mismatch, tone: 'warn' });
            if (window.__ae) window.__ae('feature_use', {
                slug: 'karaoke', f: 'autosync_done', provider: res.provider, device: res.device,
                ms: res.ms, lines: res.timeline.length, score: +(+res.score).toFixed(3),
                conf: res.medianConf == null ? null : +res.medianConf.toFixed(2),
                mismatch: res.mismatch ? 1 : 0, gated: res.gated ? 1 : 0,
                vshare: +(+res.vocalShare).toFixed(2), cached: cached ? 1 : 0, gpu_fb: res.gpuFallback ? 1 : 0,
            });
            if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'lyrics_ready', src: 'auto', lines: res.timeline.length });
        }).catch(function (err) {
            var code = (err && err.code) || 'failed';
            autoSyncRunning = false; autoSyncAbort = null;
            refreshPlainLyrics();
            if (code !== 'aborted') setSyncFace('untimed', { note: autoSyncRefusal(code), tone: code === 'no-vocals' ? 'warn' : 'err' });
            else setSyncFace('untimed', { note: LANG.as_cancelled });
            if (window.__ae) window.__ae('feature_use', {
                slug: 'karaoke', f: code === 'aborted' ? 'autosync_cancelled' : 'autosync_failed',
                reason: code, detail: String((err && err.detail) || '').slice(0, 120),
                provider: plan.provider, device: device, secs: Math.round((Date.now() - t0) / 1000),
                vshare: err && err.share != null ? +(+err.share).toFixed(2) : null,
            });
        }).then(function () {
            autoSyncRunning = false; autoSyncAbort = null;
        });
    }

    // One nudge moves the whole text: the usual error left after any automatic
    // placement is a constant one (the singer comes in a touch late or early).
    if ($as) $as.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('[data-as-shift]') : null;
        if (!b || !plainLrcLines.length || !window.KaraokeLyrics) return;
        var d = parseFloat(b.dataset.asShift);
        plainLrcLines = window.KaraokeLyrics.shift(plainLrcLines, d);
        saveSyncedTimeline();
        renderPlainKaraoke();
        if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'lyrics_shift', by: d, src: plainSyncSrc });
    });
    if ($asLrc) $asLrc.addEventListener('click', function () {
        if (!plainLrcLines.length || !window.KaraokeLyrics) return;
        var blob = new Blob([window.KaraokeLyrics.serializeLRC(plainLrcLines)], { type: 'text/plain;charset=utf-8' });
        var name = (fileName || 'lyrics') + '.lrc';
        if (window.__downloadFile) window.__downloadFile(blob, name);
        if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'lrc_export', lines: plainLrcLines.length, src: plainSyncSrc });
    });

    // ── LRC sync editor: tap each line to timestamp it against the track ──
    var $syncOpenBtn = document.getElementById('krSyncOpenBtn');
    var $syncEditor = document.getElementById('krSyncEditor');
    var $syncLines = document.getElementById('krSyncLines');
    var $syncWarn = document.getElementById('krSyncWarn');
    var $syncTap = document.getElementById('krSyncTap');
    var $syncUndo = document.getElementById('krSyncUndo');
    var $syncProgress = document.getElementById('krSyncProgress');
    var $syncDone = document.getElementById('krSyncDone');
    var $syncExport = document.getElementById('krSyncExport');
    var syncState = null;
    var syncEditorOpen = false;
    var syncFixMode = false;          // editor opened over an already placed text: fix one line, keep the rest

    // The "Sync lyrics" button shows whenever there is text to time and the
    // editor isn't already open.
    function refreshSyncOpenBtn() {
        if (!$syncOpenBtn) return;
        $syncOpenBtn.classList.toggle('active', !!$lyricsText.value.trim() && !syncEditorOpen);
    }

    function renderSyncLines() {
        if (!syncState || !$syncLines) return;
        var SE = window.KaraokeSyncEditor;
        $syncLines.innerHTML = '';
        for (var i = 0; i < syncState.lines.length; i++) {
            var ln = syncState.lines[i];
            var row = document.createElement('div');
            row.className = 'kr-sync-line' +
                (i === syncState.index ? ' current' : (ln.startS != null ? ' done' : ''));
            var txt = document.createElement('span');
            txt.textContent = ln.text;
            var time = document.createElement('span');
            time.className = 'kr-sync-line-time';
            time.textContent = ln.startS != null ? formatTime(ln.startS) : '--:--';
            row.appendChild(txt);
            row.appendChild(time);
            (function (idx) {
                row.addEventListener('click', function () {
                    SE.setIndex(syncState, idx);
                    renderSyncLines();
                    // Fixing one line of an already placed text: bring the ear to
                    // just before it, so the very next thing to do is the tap.
                    if (syncFixMode && syncState.lines[idx].startS != null) {
                        // A context that went to sleep keeps its clock still: the
                        // tap would then stamp the seek point itself, 3 s early.
                        if (audioCtx && audioCtx.state === 'suspended') { try { audioCtx.resume(); } catch (_) {} }
                        seekToTime(Math.max(0, syncState.lines[idx].startS - 3));
                        if (!isPlaying) startPlayback();
                    }
                });
            })(i);
            $syncLines.appendChild(row);
        }
        var done = SE.stampedCount(syncState);
        $syncProgress.textContent = done + ' / ' + syncState.lines.length;
        $syncWarn.classList.toggle('active', !SE.isMonotonic(syncState));
        $syncExport.disabled = done === 0;
        $syncDone.disabled = done === 0;
        // keep the current line centered — container scroll only, no page jump
        var cur = $syncLines.querySelector('.kr-sync-line.current');
        if (cur) $syncLines.scrollTop = cur.offsetTop - $syncLines.clientHeight / 2 + cur.offsetHeight / 2;
    }

    function openSyncEditor() {
        if (!window.KaraokeSyncEditor) return;
        var lines = $lyricsText.value.split('\n')
            .map(function (l) { return l.trim(); })
            .filter(function (l) { return l; });
        if (!lines.length) {
            if (window.__toast) window.__toast(LANG.sync_need_text || '', 'warning');
            return;
        }
        syncState = window.KaraokeSyncEditor.init(lines);
        // Words already placed (by the voice, or tapped earlier) arrive stamped:
        // the editor then FIXES a line — pick it, tap once — instead of making
        // the user re-tap a whole song because two choruses slipped.
        var prefilled = 0;
        if (plainLrcLines.length === lines.length && plainSyncedText === plainTextKey()) {
            for (var pi = 0; pi < lines.length; pi++) { syncState.lines[pi].startS = plainLrcLines[pi].startS; prefilled++; }
            syncState.index = lines.length;
        }
        syncFixMode = prefilled > 0;
        var $syncHint = document.getElementById('krSyncHint');
        if ($syncHint) $syncHint.textContent = (syncFixMode ? LANG.sync_hint_fix : LANG.sync_hint) || $syncHint.textContent;
        syncEditorOpen = true;
        if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'sync_editor_open', lines: lines.length, prefilled: prefilled });
        $lyricsKaraoke.classList.remove('active');
        $lyricsText.classList.add('hidden');
        $syncEditor.classList.add('active');
        refreshSyncOpenBtn();
        renderSyncLines();
        if ($syncTap) $syncTap.focus();
    }

    function closeSyncEditor() {
        syncEditorOpen = false;
        $syncEditor.classList.remove('active');
        $lyricsText.classList.remove('hidden');
        refreshSyncOpenBtn();
        refreshPlainLyrics();
    }

    /* The tap editor's stamps → a timeline. Over an already placed text the
       editor FIXES lines (KaraokeSyncEditor.applyTo): the text order never
       changes, a re-tapped line moves with its word stamps, untouched lines
       keep theirs. A from-scratch run has nothing to keep, so it takes the
       editor's own line-only timeline. */
    function mergeTappedTimeline(state) {
        var SE = window.KaraokeSyncEditor;
        var placed = plainLrcLines.length === state.lines.length && plainSyncedText === plainTextKey()
            && SE.isComplete(state) && typeof SE.applyTo === 'function';
        if (!placed) return SE.toTimeline(state);
        var r = SE.applyTo(plainLrcLines, state);
        if (!r) return SE.toTimeline(state);
        if (window.__ae && (r.moved.length || r.bunched.length)) {
            window.__ae('feature_use', { slug: 'karaoke', f: 'sync_lines_fixed', moved: r.moved.length, bunched: r.bunched.length, lines: state.lines.length });
        }
        r.timeline.__kept = true;
        return r.timeline;
    }

    if ($syncOpenBtn) $syncOpenBtn.addEventListener('click', openSyncEditor);
    if ($syncTap) $syncTap.addEventListener('click', function () {
        if (syncState) {
            // Stamps live in ORIGINAL song seconds (the base every timeline uses);
            // the transport clock is playback time, which differs under a tempo change.
            // …and a tap means "I heard it": the editor subtracts the device's
            // output latency and a person's reaction BEFORE the tempo mapping —
            // both are wall-clock seconds, not song seconds.
            var SE = window.KaraokeSyncEditor;
            window.KaraokeSyncEditor.tap(syncState, toSongTime(SE.stampTime
                ? SE.stampTime(audioCtx, getCurrentElapsed(), isPlaying && !!audioCtx)
                : getCurrentElapsed()));
            // Fixing ONE line: a second tap must not quietly re-stamp the next
            // line, which was fine — so nothing stays selected after the tap.
            if (syncFixMode) syncState.index = syncState.lines.length;
            renderSyncLines();
        }
    });
    if ($syncUndo) $syncUndo.addEventListener('click', function () {
        if (syncState) { window.KaraokeSyncEditor.undo(syncState); renderSyncLines(); }
    });
    if ($syncDone) $syncDone.addEventListener('click', function () {
        if (syncState) {
            var tl = mergeTappedTimeline(syncState);
            if (tl.length) adoptPlainTimeline(tl, plainSyncSrc === 'auto' && tl.__kept ? 'auto' : 'tap');
            // Where lyrics come from decides whether the online search is worth
            // keeping: sync_editor_open only said someone started, this says
            // they finished by hand.
            if (window.__ae) window.__ae('feature_use', {
                slug: 'karaoke', f: 'lyrics_ready', src: 'tap', lines: tl.length,
            });
        }
        closeSyncEditor();
    });
    if ($syncExport) $syncExport.addEventListener('click', function () {
        if (!syncState || !window.KaraokeLyrics) return;
        var lrc = window.KaraokeLyrics.serializeLRC(window.KaraokeSyncEditor.toTimeline(syncState));
        var blob = new Blob([lrc], { type: 'text/plain;charset=utf-8' });
        var a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = (fileName || 'lyrics') + '.lrc';
        document.body.appendChild(a);
        a.click();
        setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
        if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'lrc_export', lines: syncState.lines.length });
    });

    // ── Karaoke video export: backing track + burned animated lyrics → MP4 ──
    var $veCreate = document.getElementById('krVeCreate');
    var $veProgress = document.getElementById('krVeProgress');
    var $veProgressFill = document.getElementById('krVeProgressFill');
    var $veProgressLabel = document.getElementById('krVeProgressLabel');
    var $veDownload = document.getElementById('krVeDownload');
    var veResolution = 720;
    var veStyle = 'gradient';
    var veRunning = false;
    var veAbort = null;
    var veBlobUrl = null;
    var veBlob = null, veName = '';

    var $veRes = document.getElementById('krVeRes');
    var $veStyle = document.getElementById('krVeStyle');
    if ($veRes) $veRes.addEventListener('change', function () { veResolution = parseInt(this.value, 10); });
    if ($veStyle) $veStyle.addEventListener('change', function () { veStyle = this.value; });

    function veLabel(stage) {
        if (stage === 'transcoding') return LANG.video_transcoding || '';
        if (stage === 'done') return LANG.video_done || '';
        return LANG.video_rendering || '';
    }

    if ($veCreate) $veCreate.addEventListener('click', async function () {
        if (veRunning) { if (veAbort) veAbort.abort(); return; }
        if (!musicBuffer || !window.KaraokeVideoExport) return;
        /* The film's whole content is WHEN each line lights up. Words that have
           no times would have to be given invented ones — that is the video that
           earned feedback #1704 (116 of 170 export sessions a month had no timed
           source). Stop here and point at the two real ways to get times. */
        if (lyricsMode === 'plain' && !activeTimeline().length && plainLines().length) {
            setSyncFace('untimed', { note: LANG.as_video_needs_sync, tone: 'warn' });
            if ($as && $as.scrollIntoView) { try { $as.scrollIntoView({ block: 'nearest' }); } catch (_) {} }
            if (window.__toast) window.__toast(LANG.as_video_needs_sync || '', 'warning', 9000);
            if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'video_export_needs_sync', lines: plainLines().length });
            return;
        }
        var KVE = window.KaraokeVideoExport;

        // Key/tempo are baked into the buffer we hand the encoder, so the film
        // matches what the singer just heard — and so neither lane needs a rate
        // knob (the old pair of them cancelled out; see the block at the top).
        var exportBuffer;
        try {
            exportBuffer = await renderExportBuffer();
        } catch (e) {
            /* Do NOT quietly export the unshifted song: the sliders say +2 and
               80 %, and handing back a file that ignores both is the silent
               downgrade this codebase forbids. Say what happened and stop. */
            if (window.__handleError) window.__handleError(e, 'karaoke:video-export-shift');
            if (window.__ae) window.__ae('feature_use', {
                slug: 'karaoke', f: 'video_export_error',
                msg: String(e && e.message).slice(0, 100), code: (e && e.code) || '',
                stage: 'key_tempo_render',
            });
            return;
        }

        var exportOpts = {
            audioBuffer: exportBuffer,
            // Playback-time timeline: the burned-in progress bar and timecode
            // have to agree with the exported file's own duration.
            timeline: timelineInPlaybackTime(),
            resolution: veResolution,
            bgStyle: veStyle,
            rtl: (window.__LOCALE === 'ar'),
            emptyText: LANG.fullscreen_empty,
            fps: 25,
        };

        /* Pre-flight: if this browser has no WebCodecs MP4 encoder the only way
           left is the real-time capture + FFmpeg transcode — minutes, not
           seconds. Say so BEFORE committing, and offer the WebM exit, which is
           quick anywhere MediaRecorder exists. Same gate and same dialog as
           /slideshow-maker and /audio-to-video. Without it, 108 of 140 export
           sessions in 60 days simply vanished mid-wait. */
        var wantFormat = 'mp4';
        var forceLane = null;
        var sup = null;
        try { sup = await KVE.probeFastLane(exportOpts); } catch (_) { sup = null; }

        /* Ask before committing anyone to the real-time lane. Shared with the
           post-failure retry below, because BOTH ways of ending up on that lane
           owe the user the same warning. → 'webm' | 'recorder' | 'cancel'. */
        async function offerSlowPath(reason) {
            if (!window.CanvasVideoSlowPath || typeof window.CanvasVideoSlowPath.show !== 'function') {
                return 'recorder';   // no dialog primitive — behave as before
            }
            var est = window.CanvasVideoSlowPath.estimateSeconds({ durationSec: exportBuffer.duration });
            if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'slow_path_dialog_shown', reason: reason });
            var choice = await window.CanvasVideoSlowPath.show({
                est: est,
                strings: {
                    title: LANG.slow_export_title, body: LANG.slow_export_body,
                    useWebm: LANG.slow_export_use_webm, keepMp4: LANG.slow_export_keep_mp4,
                    cancel: LANG.slow_export_cancel,
                },
            });
            if (choice === 'cancel') {
                if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'slow_path_cancelled', reason: reason });
                return 'cancel';
            }
            if (choice === 'webm') {
                if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'slow_path_chose_webm', reason: reason });
                return 'webm';
            }
            if (window.__ae) window.__ae('feature_use', {
                slug: 'karaoke', f: 'slow_path_chose_mp4',
                reason: reason, estMin: est.minSec, estMax: est.maxSec,
            });
            if (window.__toast) window.__toast(LANG.slow_export_in_progress, 'info', 12000);
            return 'recorder';
        }

        if (!sup || !sup.ok) {
            if (!KVE.isAvailable()) {
                // No WebCodecs AND no MediaRecorder — nothing can encode here.
                if (window.__toast) window.__toast(LANG.video_unsupported || '', 'error');
                if (window.__ae) window.__ae('feature_use', {
                    slug: 'karaoke', f: 'video_export_unsupported',
                    reason: (sup && sup.reason) || 'no-primitive',
                });
                return;
            }
            var picked = await offerSlowPath((sup && sup.reason) || 'no-primitive');
            if (picked === 'cancel') return;
            if (picked === 'webm') wantFormat = 'webm';
            else forceLane = 'recorder';
        }

        veRunning = true;
        veAbort = new AbortController();
        $veCreate.disabled = true;
        $veProgress.classList.add('active');
        $veDownload.classList.remove('active');
        if (veBlobUrl) { URL.revokeObjectURL(veBlobUrl); veBlobUrl = null; }
        veBlob = null;
        if (isPlaying) stopPlayback();
        if (window.__ae) window.__ae('feature_use', {
            slug: 'karaoke', f: 'video_export_start', res: veResolution,
            fmt: wantFormat, lane: forceLane === 'recorder' ? 'recorder' : (sup && sup.ok ? 'webcodecs' : 'recorder'),
            durSec: Math.round(exportBuffer.duration),
        });
        var t0 = (window.performance && performance.now) ? performance.now() : 0;
        try {
            exportOpts.format = wantFormat;
            if (forceLane) exportOpts.forceLane = forceLane;
            var onProg = function (r, stage) {
                $veProgressFill.style.width = Math.round(r * 100) + '%';
                $veProgressLabel.textContent = veLabel(stage) + ' ' + Math.round(r * 100) + '%';
            };
            var blob;
            if (wantFormat === 'webm') {
                blob = await KVE.exportWebm(exportOpts, onProg, veAbort.signal);
            } else {
                try {
                    blob = await KVE.exportMp4(exportOpts, onProg, veAbort.signal);
                } catch (e1) {
                    /* The fast lane broke on this particular content even though
                       the probe said it could encode (~1 % of exports on the
                       tools already using the primitive). The recorder lane can
                       still salvage it, but it costs minutes — so ask, exactly
                       as if the probe had failed, instead of smuggling the user
                       into the wait that produced this bug report. */
                    if (e1 && e1.code === 'FAST_LANE_FAILED' && e1.canRetryWithRecorder && !veAbort.signal.aborted) {
                        var retry = await offerSlowPath('fast_lane_failed');
                        if (retry === 'cancel') throw new Error('aborted');
                        if (retry === 'webm') {
                            wantFormat = 'webm';
                            exportOpts.format = 'webm';
                            blob = await KVE.exportWebm(exportOpts, onProg, veAbort.signal);
                        } else {
                            exportOpts.forceLane = 'recorder';
                            blob = await KVE.exportMp4(exportOpts, onProg, veAbort.signal);
                        }
                    } else {
                        throw e1;
                    }
                }
            }
            veBlobUrl = URL.createObjectURL(blob);
            veBlob = blob;
            veName = (fileName || 'karaoke') + '-karaoke.' + (wantFormat === 'webm' ? 'webm' : 'mp4');
            $veDownload.href = veBlobUrl;
            $veDownload.download = veName;
            $veDownload.classList.add('active');
            $veProgressLabel.textContent = LANG.video_done || '';
            if (window.__ae) window.__ae('feature_use', {
                slug: 'karaoke', f: 'video_export_done', res: veResolution, guide: vocalGuide,
                sizeMB: Math.round(blob.size / 1048576), fmt: wantFormat,
                ms: t0 ? Math.round(performance.now() - t0) : 0,
                durSec: Math.round(exportBuffer.duration),
            });
        } catch (err) {
            var msg = String(err && err.message);
            if (msg !== 'aborted' && !(err && err.name === 'AbortError')) {
                console.error('Karaoke video export failed:', err);
                // A stalled capture has its own sentence: the cure is "keep the
                // tab in front", which a generic failure toast would not say.
                var stalled = err && err.code === 'CAPTURE_STALLED';
                if (window.__toast) {
                    window.__toast(
                        (stalled ? LANG.export_stalled : LANG.video_failed) || 'Export failed',
                        'error', stalled ? 12000 : undefined
                    );
                }
                if (window.__ae) window.__ae('feature_use', {
                    slug: 'karaoke', f: 'video_export_error',
                    msg: msg.slice(0, 100), code: (err && err.code) || '',
                    ctxState: (err && err.ctxState) || '', atSec: (err && err.atSec) || 0,
                    fmt: wantFormat, res: veResolution,
                });
            }
            $veProgress.classList.remove('active');
        } finally {
            veRunning = false;
            veAbort = null;
            $veCreate.disabled = false;
        }
    });

    /* The video goes out through the shared download door, like the recording
       does. As a bare <a download> it saved the file and SAID NOTHING: in the
       session behind feedback #1704 «Скачать видео» was pressed ten times in a
       row (rage_click + silent_click) and ten copies landed on disk. The door
       confirms the save, and it is the path that works in Android WebView. */
    if ($veDownload) $veDownload.addEventListener('click', function (e) {
        if (!veBlob || !window.__downloadFile) return;
        e.preventDefault();
        window.__downloadFile(veBlob, veName || 'karaoke.mp4');
    });

    // ── Pitch scoring (Phase 7) ──────────────────────────────────────────
    var $scoreToggle = document.getElementById('krScoreToggle');
    var $scoreDiff = document.getElementById('krScoreDiff');
    var $scorePanel = document.getElementById('krScorePanel');
    var $scoreMeterFill = document.getElementById('krScoreMeterFill');
    var $scoreValue = document.getElementById('krScoreValue');
    var scoringEnabled = false;
    var scoreDifficulty = 'normal';
    var scoreReference = null;
    var scorer = null;
    var scorePitchBuf = null;
    var lastScoreTick = 0;

    document.querySelectorAll('#krScoreDiff .kr-score-diff-btn').forEach(function (b) {
        b.addEventListener('click', function () {
            document.querySelectorAll('#krScoreDiff .kr-score-diff-btn').forEach(function (x) { x.classList.remove('active'); });
            b.classList.add('active');
            scoreDifficulty = b.dataset.diff;
        });
    });

    if ($scoreToggle) $scoreToggle.addEventListener('click', async function () {
        if (scoringEnabled) {
            scoringEnabled = false;
            $scoreToggle.classList.remove('on');
            $scoreToggle.textContent = LANG.scoring_enable || '';
            $scorePanel.classList.remove('active');
            return;
        }
        // Reference melody = imported MIDI/UltraStar notes if present, else the
        // separated vocal stem. A pure backing-track upload with neither can't
        // be scored.
        if (!window.KaraokeScoring || (!fullVocalBuffer && !importedNotes)) {
            if (window.__toast) window.__toast(LANG.scoring_no_reference || '', 'warning');
            return;
        }
        if (!scoreReference) {
            if (importedNotes) {
                // Imported notes ARE the reference — instant, no stem needed.
                scoreReference = window.KaraokeScoring.referenceFromNotes(importedNotes);
            } else {
                $scoreToggle.disabled = true;
                $scoreToggle.textContent = LANG.scoring_building || '';
                try {
                    scoreReference = await window.KaraokeScoring.buildReference(fullVocalBuffer);
                } catch (e) { scoreReference = null; }
                $scoreToggle.disabled = false;
            }
            if (!scoreReference) {
                $scoreToggle.textContent = LANG.scoring_enable || '';
                if (window.__toast) window.__toast(LANG.scoring_no_reference || '', 'warning');
                return;
            }
        }
        scoringEnabled = true;
        $scoreToggle.classList.add('on');
        $scoreToggle.textContent = LANG.scoring_disable || '';
        $scorePanel.classList.add('active');
        $scoreValue.textContent = LANG.scoring_hint || '';
        $scoreMeterFill.style.width = '0';
        if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'scoring_enable', difficulty: scoreDifficulty });
    });

    function resetScorer() {
        if (scoringEnabled && window.KaraokeScoring && scoreReference) {
            scorer = window.KaraokeScoring.createScorer(scoreReference, { difficulty: scoreDifficulty });
            $scoreMeterFill.style.width = '0';
            $scoreValue.textContent = LANG.scoring_hint || '';
        }
    }

    // Sample the live mic pitch and feed the scorer — called from updateCursor.
    function scoringTick(elapsed) {
        if (!scoringEnabled || !scorer || !micEnabled || !micAnalyser) return;
        var now = performance.now();
        if (now - lastScoreTick < 50) return;   // ~20 Hz is plenty
        lastScoreTick = now;
        if (!scorePitchBuf || scorePitchBuf.length !== micAnalyser.fftSize) {
            scorePitchBuf = new Float32Array(micAnalyser.fftSize);
        }
        micAnalyser.getFloatTimeDomainData(scorePitchBuf);
        var hz = window.KaraokeScoring.detectPitch(scorePitchBuf, audioCtx.sampleRate);
        scorer.add(elapsed, hz);
        var r = scorer.result();
        $scoreMeterFill.style.width = r.score + '%';
        if (r.scoredFrames > 0) $scoreValue.textContent = (LANG.scoring_live || '') + ' ' + r.score + '%';
    }

    // Takes of this sitting. One number is a score; several are progress, and
    // progress is what brings a singer back tomorrow.
    var sessionTakes = [];

    function renderSession() {
        if (!window.KaraokeSession || !$session) return;
        var s = window.KaraokeSession.sessionSummary(sessionTakes);
        if (!s || s.takes < 1) { $session.hidden = true; return; }
        $session.hidden = false;
        $sessionGrade.textContent = s.grade;
        var line = (LANG.session_line || '')
            .replace('{takes}', s.takes).replace('{best}', s.best).replace('{avg}', s.avg);
        if (s.trend > 0) line += ' · ' + (LANG.session_trend || '').replace('{n}', '+' + s.trend);
        $sessionLine.textContent = line;
    }

    function finishScoring() {
        if (!scoringEnabled || !scorer) return;
        var r = scorer.result();
        if (r.scoredFrames < 5) return;          // too short to be meaningful
        $scoreMeterFill.style.width = r.score + '%';
        $scoreValue.innerHTML = '<span class="kr-score-final">' + r.score + '</span> / 100';
        sessionTakes.push({ score: r.score, at: Date.now() });
        renderSession();
        if (window.__ae) window.__ae('feature_use', {
            slug: 'karaoke', f: 'scoring_result',
            score: r.score, difficulty: scoreDifficulty, frames: r.scoredFrames,
            take: sessionTakes.length,
        });
    }

    if ($sessionShare) $sessionShare.addEventListener('click', async function () {
        var s = window.KaraokeSession && window.KaraokeSession.sessionSummary(sessionTakes);
        if (!s) return;
        var text = (LANG.session_share_text || '')
            .replace('{score}', s.best).replace('{name}', fileName || '');
        var url = location.origin + location.pathname;
        try {
            // Native share sheet where there is one (phones), clipboard elsewhere.
            if (navigator.share) {
                await navigator.share({ title: 'Timbrica', text: text, url: url });
            } else {
                await navigator.clipboard.writeText(text + ' ' + url);
                if (window.__toast) window.__toast(LANG.session_copied, 'success');
            }
            if (window.__ae) window.__ae('feature_use', {
                slug: 'karaoke', f: 'session_share',
                best: s.best, takes: s.takes, native: navigator.share ? 1 : 0,
            });
        } catch (_) { /* user dismissed the sheet — not an error */ }
    });

    // ═══════════════════════════════════════
    // Saved songs — the tuning survives a reload, the audio never leaves disk
    // ═══════════════════════════════════════

    var pendingSong = null;   // settings waiting for the user to re-pick the file

    function currentLyricsText() {
        return lyricsMode === 'lrc'
            ? ($lrcPaste ? $lrcPaste.value : '')
            : ($lyricsText ? $lyricsText.value : '');
    }

    function renderSongs() {
        if (!window.KaraokeSession || !$songsList || !$songs) return;
        var list = window.KaraokeSession.listSongs();
        if (!list.length) { $songs.hidden = true; return; }
        $songs.hidden = false;
        $songsList.innerHTML = '';
        list.forEach(function (s) {
            var row = document.createElement('div');
            row.className = 'kr-song';

            var main = document.createElement('div');
            main.className = 'kr-song-main';
            var name = document.createElement('div');
            name.className = 'kr-song-name';
            name.textContent = s.name;
            var meta = document.createElement('div');
            meta.className = 'kr-song-meta';
            var bits = [];
            if (s.keyShift) bits.push((s.keyShift > 0 ? '+' : '') + s.keyShift + ' ' + (LANG.key_semitones || ''));
            if (s.tempo && s.tempo !== 100) bits.push(s.tempo + '%');
            if (s.lyrics) bits.push(LANG.songs_has_lyrics || '');
            if (s.bestScore) bits.push(s.bestScore + '/100');
            meta.textContent = bits.join(' · ') || (LANG.songs_no_tuning || '');
            main.appendChild(name); main.appendChild(meta);

            var open = document.createElement('button');
            open.type = 'button';
            open.className = 'kr-song-btn';
            open.textContent = LANG.songs_open || 'Open';
            open.addEventListener('click', function () { openSavedSong(s); });

            var del = document.createElement('button');
            del.type = 'button';
            del.className = 'kr-song-btn danger';
            del.textContent = LANG.songs_delete || 'Delete';
            del.addEventListener('click', function () {
                window.KaraokeSession.deleteSong(s.id);
                renderSongs();
            });

            row.appendChild(main); row.appendChild(open); row.appendChild(del);
            $songsList.appendChild(row);
        });
    }

    // Apply everything that does not need the audio, then ask for the file.
    function openSavedSong(s) {
        pendingSong = s;
        if ($lrcPaste && s.lyricsMode === 'lrc') $lrcPaste.value = s.lyrics || '';
        if ($lyricsText && s.lyricsMode !== 'lrc') $lyricsText.value = s.lyrics || '';
        var modeBtn = document.querySelector('.kr-mode-btn[data-mode="' + s.mode + '"]');
        if (modeBtn) modeBtn.click();
        if (window.__toast) window.__toast((LANG.songs_pick_file || '').replace('{name}', s.name), 'info');
        var input = document.querySelector('#krUpload input[type=file]');
        if (input) input.click();
        if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'song_open' });
    }

    // Called once the track is analysed: restore the tuning that belongs to it.
    function applyPendingSong() {
        var s = pendingSong;
        pendingSong = null;
        if (!s) {
            // Not opened from the shelf — but the same file may still be known.
            s = window.KaraokeSession && originalBuffer
                ? window.KaraokeSession.findSong(fileName, originalBuffer.duration)
                : null;
            if (!s) return;
        }
        if ($keySlider && s.keyShift) { $keySlider.value = s.keyShift; $keySlider.dispatchEvent(new Event('input', { bubbles: true })); }
        if ($tempoSlider && s.tempo && s.tempo !== 100) { $tempoSlider.value = s.tempo; $tempoSlider.dispatchEvent(new Event('input', { bubbles: true })); }
        if ($guideSlider && s.guide != null) { $guideSlider.value = s.guide; $guideSlider.dispatchEvent(new Event('input', { bubbles: true })); }
        if (s.reverb && s.reverb !== 'off') {
            var rb = document.querySelector('.kr-reverb-btn[data-reverb="' + s.reverb + '"]');
            if (rb) rb.click();
        }
        if (s.lyrics) {
            if (s.lyricsMode === 'lrc') {
                var lrcTab = document.querySelector('.kr-lyrics-mode-btn[data-mode="lrc"]');
                if (lrcTab) lrcTab.click();
                if ($lrcPaste) { $lrcPaste.value = s.lyrics; loadLRCText(s.lyrics); }
            } else if ($lyricsText) {
                $lyricsText.value = s.lyrics;
                $lyricsText.dispatchEvent(new Event('input', { bubbles: true }));
            }
        }
        if (window.__toast) window.__toast(LANG.songs_restored, 'success');
        if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'song_restored' });
    }

    if ($saveSong) $saveSong.addEventListener('click', function () {
        if (!window.KaraokeSession || !originalBuffer) return;
        var best = window.KaraokeSession.sessionSummary(sessionTakes);
        var rec = window.KaraokeSession.saveSong({
            name: fileName,
            dur: originalBuffer.duration,
            bpm: detectedBPM,
            musicKey: $key ? $key.textContent : '',
            mode: processingMode,
            keyShift: currentKey,
            tempo: Math.round(currentTempo * 100),
            guide: vocalGuide,
            reverb: currentReverb,
            lyrics: currentLyricsText(),
            lyricsMode: lyricsMode,
            bestScore: best ? best.best : 0,
            savedAt: new Date().toISOString(),
        });
        if (!rec) {
            if (window.__toast) window.__toast(LANG.songs_save_failed, 'error');
            return;
        }
        renderSongs();
        if (window.__toast) window.__toast(LANG.songs_saved, 'success');
        if (window.__ae) window.__ae('feature_use', {
            slug: 'karaoke', f: 'song_saved',
            hasLyrics: rec.lyrics ? 1 : 0, keyShift: rec.keyShift, tempo: rec.tempo,
        });
    });

    // ═══════════════════════════════════════
    // Key fit — the singer's measured range vs what this track actually sings
    // ═══════════════════════════════════════

    var fitSuggestion = null;

    async function computeKeyFit() {
        if (!window.KaraokeSession || !$fit) return;
        var userRange = window.KaraokeSession.readUserRange();
        if (!userRange) {
            // No measurement yet — point at the tool that makes one, once.
            $fit.hidden = false;
            $fitText.innerHTML = LANG.range_none || '';
            if ($fitApply) $fitApply.hidden = true;
            return;
        }
        if (!fullVocalBuffer || !window.PitchTracker) { $fit.hidden = true; return; }
        $fit.hidden = false;
        $fitText.textContent = LANG.range_analyzing || '';
        if ($fitApply) $fitApply.hidden = true;
        try {
            var tracked = await window.PitchTracker.track(fullVocalBuffer, { hopSec: 0.05, minConf: 0.8 });
            var songRange = window.KaraokeSession.rangeFromFrames(tracked.frames);
            var s = window.KaraokeSession.suggestKeyShift(songRange, userRange);
            if (!s) { $fit.hidden = true; return; }
            fitSuggestion = s;
            var range = s.userLowName + '–' + s.userHighName;
            var songSpan = s.songLowName + '–' + s.songHighName;
            if (s.shift === 0) {
                $fitText.textContent = (LANG.range_fits || '').replace('{user}', range).replace('{song}', songSpan);
                if ($fitApply) $fitApply.hidden = true;
            } else {
                $fitText.textContent = (LANG.range_suggest || '')
                    .replace('{user}', range).replace('{song}', songSpan)
                    .replace('{shift}', (s.shift > 0 ? '+' : '') + s.shift);
                if ($fitApply) $fitApply.hidden = false;
            }
            if (window.__ae) window.__ae('feature_use', {
                slug: 'karaoke', f: 'key_fit_shown', shift: s.shift, fits: s.fits ? 1 : 0,
            });
        } catch (_) { $fit.hidden = true; }
    }

    if ($fitApply) $fitApply.addEventListener('click', function () {
        if (!fitSuggestion || !$keySlider) return;
        $keySlider.value = fitSuggestion.shift;
        $keySlider.dispatchEvent(new Event('input', { bubbles: true }));
        this.hidden = true;
        if (window.__ae) window.__ae('feature_use', {
            slug: 'karaoke', f: 'key_fit_applied', shift: fitSuggestion.shift,
        });
    });

    renderSongs();

    // ── Lyrics mode tabs ──
    document.querySelectorAll('.kr-lyrics-mode-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
            document.querySelectorAll('.kr-lyrics-mode-btn').forEach(function(b) { b.classList.remove('active'); });
            btn.classList.add('active');
            lyricsMode = btn.dataset.mode;

            var $plain = document.getElementById('krLyricsPlain');
            var $lrc = document.getElementById('krLyricsLrc');
            if (lyricsMode === 'lrc') {
                $plain.classList.remove('active');
                $lrc.classList.add('active');
            } else {
                $lrc.classList.remove('active');
                $plain.classList.add('active');
                lrcActive = false;
            }
            updateFindLrcButton();
        });
    });

    // ── FFT Engine ──
    function fftInPlace(re, im) {
        var n = re.length, half = n >> 1;
        for (var i = 1, j = 0; i < n; i++) {
            var bit = half;
            while (j & bit) { j ^= bit; bit >>= 1; }
            j ^= bit;
            if (i < j) {
                var t = re[i]; re[i] = re[j]; re[j] = t;
                t = im[i]; im[i] = im[j]; im[j] = t;
            }
        }
        for (var len = 2; len <= n; len <<= 1) {
            var ang = -2 * Math.PI / len, wR = Math.cos(ang), wI = Math.sin(ang);
            for (var i = 0; i < n; i += len) {
                var curR = 1, curI = 0;
                for (var j = 0; j < (len >> 1); j++) {
                    var uR = re[i+j], uI = im[i+j];
                    var vR = re[i+j+(len>>1)] * curR - im[i+j+(len>>1)] * curI;
                    var vI = re[i+j+(len>>1)] * curI + im[i+j+(len>>1)] * curR;
                    re[i+j] = uR + vR; im[i+j] = uI + vI;
                    re[i+j+(len>>1)] = uR - vR; im[i+j+(len>>1)] = uI - vI;
                    var nR = curR * wR - curI * wI;
                    curI = curR * wI + curI * wR;
                    curR = nR;
                }
            }
        }
    }
    function ifftInPlace(re, im) {
        var n = re.length;
        for (var i = 0; i < n; i++) im[i] = -im[i];
        fftInPlace(re, im);
        for (var i = 0; i < n; i++) { re[i] /= n; im[i] = -im[i] / n; }
    }

    // ── Separation Engine (STFT spectral masking) ──
    function separateVocals(buffer, str) {
        var ch = buffer.numberOfChannels;
        var len = buffer.length;
        var sr = buffer.sampleRate;
        var L = buffer.getChannelData(0);
        var R = ch > 1 ? buffer.getChannelData(1) : L;
        var isMono = ch < 2;

        var instrBuf = window.__safeAudioBuffer({ length: len, numberOfChannels: 2, sampleRate: sr });
        var vocalBuf = window.__safeAudioBuffer({ length: len, numberOfChannels: 2, sampleRate: sr });

        if (isMono) {
            var d0 = instrBuf.getChannelData(0), d1 = instrBuf.getChannelData(1);
            var v0 = vocalBuf.getChannelData(0), v1 = vocalBuf.getChannelData(1);
            for (var i = 0; i < len; i++) { d0[i] = d1[i] = L[i]; v0[i] = v1[i] = L[i]; }
            return { instrumental: instrBuf, vocal: vocalBuf, mono: true };
        }

        var N = 4096, hop = 1024, half = N >> 1;
        // Centred frames: three virtual frames start before sample 0, so every
        // sample of the song is covered by four windows. Frames that began at
        // sample 0 left the first 3·hop samples under one to three windows; the
        // division by that window sum zeroed the first ~13 samples and blew the
        // mask's changes up by 1/win² after them — a full-scale click at the
        // start of the backing and the vocal (measured on /vocal-remover, the
        // same engine, 07.10.2026: 42 of 50 MUSDB18 songs at full scale).
        var PAD = N - hop;
        var numFrames = Math.ceil(len / hop) + 3 + PAD / hop;

        var win = new Float32Array(N);
        for (var i = 0; i < N; i++) win[i] = 0.5 * (1 - Math.cos(2 * Math.PI * i / N));

        var hzPerBin = sr / N;
        var vWeight = new Float32Array(half + 1);
        for (var k = 0; k <= half; k++) {
            var f = k * hzPerBin, w = 1;
            if (f < 100) w = 0;
            else if (f < 250) w = (f - 100) / 150;
            if (f > 12000) w = 0;
            else if (f > 7000) w *= 1 - (f - 7000) / 5000;
            vWeight[k] = w;
        }

        var oVL = new Float32Array(len), oVR = new Float32Array(len);
        var oIL = new Float32Array(len), oIR = new Float32Array(len);
        var wSum = new Float32Array(len);

        var lR = new Float32Array(N), lI = new Float32Array(N);
        var rR = new Float32Array(N), rI = new Float32Array(N);
        var tR = new Float32Array(N), tI = new Float32Array(N);

        for (var f = 0; f < numFrames; f++) {
            var off = f * hop - PAD;
            for (var i = 0; i < N; i++) {
                var idx = off + i, w2 = win[i], inside = idx >= 0 && idx < len;
                lR[i] = inside ? L[idx] * w2 : 0; lI[i] = 0;
                rR[i] = inside ? R[idx] * w2 : 0; rI[i] = 0;
            }
            fftInPlace(lR, lI);
            fftInPlace(rR, rI);

            for (var k = 0; k <= half; k++) {
                var mR = (lR[k] + rR[k]) * 0.5;
                var mI = (lI[k] + rI[k]) * 0.5;
                var sR2 = (lR[k] - rR[k]) * 0.5;
                var sI = (lI[k] - rI[k]) * 0.5;
                var midMag = mR * mR + mI * mI;
                var sideMag = sR2 * sR2 + sI * sI;
                var total = midMag + sideMag + 1e-20;
                var center = midMag / total;
                var mask = center * center * vWeight[k] * str;
                if (mask > 1) mask = 1;
                var vcR = mR * mask;
                var vcI = mI * mask;
                tR[k] = vcR; tI[k] = vcI;
                lR[k] -= vcR; lI[k] -= vcI;
                rR[k] -= vcR; rI[k] -= vcI;
                if (k > 0 && k < half) {
                    var k2 = N - k;
                    tR[k2] = vcR; tI[k2] = -vcI;
                    lR[k2] = lR[k2] - vcR; lI[k2] = lI[k2] + vcI;
                    rR[k2] = rR[k2] - vcR; rI[k2] = rI[k2] + vcI;
                }
            }
            ifftInPlace(tR, tI);
            ifftInPlace(lR, lI);
            ifftInPlace(rR, rI);
            for (var i = 0; i < N; i++) {
                var idx = off + i;
                if (idx < 0) continue;
                if (idx >= len) break;
                var w2 = win[i];
                oVL[idx] += tR[i] * w2;
                oVR[idx] += tR[i] * w2;
                oIL[idx] += lR[i] * w2;
                oIR[idx] += rR[i] * w2;
                wSum[idx] += w2 * w2;
            }
        }

        var iLd = instrBuf.getChannelData(0), iRd = instrBuf.getChannelData(1);
        var vLd = vocalBuf.getChannelData(0), vRd = vocalBuf.getChannelData(1);
        for (var i = 0; i < len; i++) {
            var norm = wSum[i] > 1e-8 ? 1 / wSum[i] : 0;
            iLd[i] = oIL[i] * norm;
            iRd[i] = oIR[i] * norm;
            vLd[i] = oVL[i] * norm;
            vRd[i] = oVR[i] * norm;
        }
        return { instrumental: instrBuf, vocal: vocalBuf, mono: false };
    }

    // ── Fast strength remix ──
    var _geomRefusedFor = null;
    /* The backing = the song minus the WHOLE vocal. The guide is no longer
       folded in here (it plays on its own, see guideSource), so this runs once
       per separation, not on every guide move — and no scaled vocal copy is
       kept: the old one (78 MB on 3:42) was written on every remix and read by
       nobody. */
    function buildBacking() {
        if (!fullMusicBuffer || !fullVocalBuffer || !originalBuffer) return;
        // Поиндексное вычитание ⇒ дорожки обязаны лежать на часах оригинала.
        // Тот же контракт и тот же немой отказ, что разобран в
        // /vocal-remover (applyStrengthMix, 06.09.2026): движок MDX отдавал
        // 44100 при любом входе, и на 48-кГц песне вокал не гасился, а
        // добавлялся вторым ускоренным голосом. Держит предусловие движок;
        // проверяем здесь, чтобы нарушение перестало быть немым.
        if (fullVocalBuffer.sampleRate !== originalBuffer.sampleRate
            || fullVocalBuffer.length !== originalBuffer.length) {
            try { window.__ae && window.__ae('feature_use', { slug: 'karaoke', f: 'stem_geometry_mismatch',
                src_sr: originalBuffer.sampleRate, stem_sr: fullVocalBuffer.sampleRate,
                src_len: originalBuffer.length, stem_len: fullVocalBuffer.length }); } catch (_) {}
            if (_geomRefusedFor !== originalBuffer) {
                _geomRefusedFor = originalBuffer;
                try { window.__toast && window.__toast((window.KR_LANG && KR_LANG.err_separation) || 'Separation failed', 'error'); } catch (_) {}
            }
            return;
        }
        var len = originalBuffer.length;
        var sr = originalBuffer.sampleRate;
        var origL = originalBuffer.getChannelData(0);
        var origR = originalBuffer.numberOfChannels > 1 ? originalBuffer.getChannelData(1) : origL;
        var fvL = fullVocalBuffer.getChannelData(0);
        var fvR = fullVocalBuffer.getChannelData(1);

        musicBuffer = window.__safeAudioBuffer({ length: len, numberOfChannels: 2, sampleRate: sr });
        musicBufferGen++;   // new backing ⇒ any key/tempo render over the old one is stale
        var mL = musicBuffer.getChannelData(0), mR = musicBuffer.getChannelData(1);

        for (var i = 0; i < len; i++) {
            mL[i] = origL[i] - fvL[i];
            mR[i] = origR[i] - fvR[i];
        }
    }

    // ═══════════════════════════════════════
    // MODULE 5: AI Vocal Separation (ONNX)
    // ═══════════════════════════════════════

    var onnxSession = null;
    // Route the ~30 MB model through AssetRouter instead of a bare relative
    // path. A relative URL is served by whichever origin rendered the page —
    // which for tembrica.com is the NL box, exactly the one whose egress is
    // metered and which heavy() exists to keep out of the ML path. RU keeps
    // being served locally either way. Falls back to the old path if the meta
    // is missing (e.g. a cached HTML from before this shipped).
    var _mMeta = document.querySelector('meta[name="kr-model-url"]');
    var _mMetaFb = document.querySelector('meta[name="kr-model-url-fallback"]');
    var MODEL_URL = (_mMeta && _mMeta.content) || '/vendor/onnx/vocal-remover-fp16.onnx';
    var MODEL_URL_FALLBACK = (_mMetaFb && _mMetaFb.content) || '/vendor/onnx/vocal-remover-fp16.onnx';
    var AI_NFFT = 2048;
    var AI_HOP = 1024;
    var AI_FREQ = (AI_NFFT >> 1) + 1; // 1025
    var AI_MODEL_BINS = 1024; // model input uses 1024 bins (crops last bin)

    function yieldFrame() { return new Promise(function(r) { setTimeout(r, 0); }); }

    // Lazy-load ONNX Runtime
    function loadOrt() {
        if (window.ort) return Promise.resolve();
        return new Promise(function(resolve, reject) {
            var s = document.createElement('script');
            s.src = window.KR_ORT_URL || '/vendor/onnxruntime/ort.min.js';
            s.onload = resolve;
            s.onerror = function() { var s2=document.createElement('script');s2.src='/vendor/onnxruntime/ort.min.js';s2.onload=resolve;s2.onerror=function(){reject(new Error('Failed to load ONNX Runtime'))};document.head.appendChild(s2); };
            document.head.appendChild(s);
        });
    }

    // Load ONNX model with progress
    async function loadAiModel(onProgress) {
        if (onnxSession) return;
        await loadOrt();
        // The shared resumable loader (public/js/model-download.js): a cut
        // connection continues from its byte by Range instead of starting the
        // 30 MB over, and a truncated body never passes for a model. Without the
        // script (an old cached page) — one plain fetch, as before.
        var dl = typeof window.__mdFetchBytes === 'function' ? window.__mdFetchBytes : null;
        var onBytes = function (got, total) { if (onProgress && total) onProgress(got / total); };
        var fetchModel = function (url) {
            if (dl) return dl(url, { onProgress: onBytes });
            return fetch(url).then(function (r) {
                if (!r.ok) throw new Error('Model not found (' + r.status + ')');
                return r.arrayBuffer();
            }).then(function (ab) { return new Uint8Array(ab); });
        };
        var modelData;
        try {
            modelData = await fetchModel(MODEL_URL);
        } catch (primaryErr) {
            // Primary mirror unreachable (RKN-blocked host, CDN hiccup, 404 on a
            // half-synced release) — the other origin carries the same file.
            if (MODEL_URL_FALLBACK === MODEL_URL) throw primaryErr;
            if (window.__ae) window.__ae('feature_use', {
                slug: 'karaoke', f: 'model_fallback',
                err: String((primaryErr && primaryErr.message) || '').slice(0, 40),
            });
            modelData = await fetchModel(MODEL_URL_FALLBACK);
        }
        ort.env.wasm.numThreads = Math.min(navigator.hardwareConcurrency || 4, 4);
        onnxSession = await ort.InferenceSession.create(modelData, {
            executionProviders: ['wasm'],
            graphOptimizationLevel: 'all'
        });
    }

    // STFT for one channel → magnitude + unit-phase
    function aiSTFT(data, nfft, hop) {
        var len = data.length, half = nfft >> 1, freqBins = half + 1;
        var numFrames = Math.floor((len - nfft) / hop) + 1;
        var win = new Float32Array(nfft);
        for (var i = 0; i < nfft; i++) win[i] = 0.5 * (1 - Math.cos(2 * Math.PI * i / nfft));
        var mag = [], pRe = [], pIm = [];
        for (var f = 0; f < numFrames; f++) {
            var off = f * hop;
            var re = new Float32Array(nfft), im = new Float32Array(nfft);
            for (var i = 0; i < nfft; i++) { re[i] = (off + i < len ? data[off + i] : 0) * win[i]; }
            fftInPlace(re, im);
            var m = new Float32Array(freqBins), pr = new Float32Array(freqBins), pi = new Float32Array(freqBins);
            for (var k = 0; k < freqBins; k++) {
                var mg = Math.sqrt(re[k] * re[k] + im[k] * im[k]);
                m[k] = mg;
                var inv = 1 / (mg + 1e-20);
                pr[k] = re[k] * inv;
                pi[k] = im[k] * inv;
            }
            mag.push(m); pRe.push(pr); pIm.push(pi);
        }
        return { mag: mag, pRe: pRe, pIm: pIm, numFrames: numFrames, freqBins: freqBins };
    }

    // iSTFT from magnitude + unit-phase
    function aiISTFT(mag, pRe, pIm, nfft, hop, outLen) {
        var half = nfft >> 1, numFrames = mag.length;
        var win = new Float32Array(nfft);
        for (var i = 0; i < nfft; i++) win[i] = 0.5 * (1 - Math.cos(2 * Math.PI * i / nfft));
        var output = new Float32Array(outLen), wSum = new Float32Array(outLen);
        for (var f = 0; f < numFrames; f++) {
            var off = f * hop;
            var re = new Float32Array(nfft), im = new Float32Array(nfft);
            for (var k = 0; k <= half; k++) {
                re[k] = mag[f][k] * pRe[f][k];
                im[k] = mag[f][k] * pIm[f][k];
            }
            for (var k = 1; k < half; k++) { re[nfft - k] = re[k]; im[nfft - k] = -im[k]; }
            ifftInPlace(re, im);
            for (var i = 0; i < nfft; i++) {
                var idx = off + i;
                if (idx < outLen) { output[idx] += re[i] * win[i]; wSum[idx] += win[i] * win[i]; }
            }
        }
        for (var i = 0; i < outLen; i++) { if (wSum[i] > 1e-8) output[i] /= wSum[i]; }
        return output;
    }

    // AI vocal separation: STFT → ONNX model → iSTFT
    async function aiSeparateVocals(buffer, progressCb) {
        var ch = buffer.numberOfChannels;
        var len = buffer.length, sr = buffer.sampleRate;
        var L = buffer.getChannelData(0);
        var R = ch > 1 ? buffer.getChannelData(1) : L;
        var isMono = ch < 2;

        // 1) Load model
        progressCb(20, LANG.ai_loading);
        await loadAiModel(function(pct) {
            progressCb(20 + pct * 15, LANG.ai_loading + ' (' + Math.round(pct * 100) + '%)');
        });

        // 2) STFT both channels
        progressCb(36, LANG.ai_stft);
        await yieldFrame();
        var stftL = aiSTFT(L, AI_NFFT, AI_HOP);
        await yieldFrame();
        var stftR = aiSTFT(R, AI_NFFT, AI_HOP);
        var nf = stftL.numFrames, fb = stftL.freqBins; // fb=1025
        var mb = AI_MODEL_BINS; // 1024 — model input bins

        // 3) Run model in chunks — model outputs instrumental mask (sigmoid 0-1)
        progressCb(42, LANG.ai_processing);
        await yieldFrame();
        var CHUNK = 256, OVERLAP = 32, STEP = CHUNK - 2 * OVERLAP;
        var numChunks = Math.ceil(nf / STEP);
        var inputName = onnxSession.inputNames[0];
        var outputName = onnxSession.outputNames[0];

        // Allocate instrumental mask arrays (full 1025 bins, model outputs 1025)
        var maskL = new Array(nf), maskR = new Array(nf);
        for (var i = 0; i < nf; i++) { maskL[i] = new Float32Array(fb); maskR[i] = new Float32Array(fb); }

        for (var c = 0; c < numChunks; c++) {
            var cs = c * STEP;
            // Build input tensor [1, 2, 1024, CHUNK] — model expects 1024 freq bins
            var inp = new Float32Array(2 * mb * CHUNK);
            for (var f = 0; f < CHUNK; f++) {
                var sf = cs + f;
                if (sf < nf) {
                    for (var k = 0; k < mb; k++) {
                        inp[k * CHUNK + f] = stftL.mag[sf][k];
                        inp[mb * CHUNK + k * CHUNK + f] = stftR.mag[sf][k];
                    }
                }
            }
            var tensor = new ort.Tensor('float32', inp, [1, 2, mb, CHUNK]);
            var feeds = {}; feeds[inputName] = tensor;
            var res = await onnxSession.run(feeds);
            var out = res[outputName].data; // [1, 2, 1025, CHUNK] — instrumental mask

            // Extract mask with overlap blending
            for (var f = 0; f < CHUNK; f++) {
                var df = cs + f;
                if (df >= nf) break;
                var w = 1.0;
                if (c > 0 && f < OVERLAP) w = f / OVERLAP;
                if (f >= CHUNK - OVERLAP && c < numChunks - 1) w = (CHUNK - f) / OVERLAP;
                for (var k = 0; k < fb; k++) {
                    var ml = out[k * CHUNK + f];
                    var mr = out[fb * CHUNK + k * CHUNK + f];
                    if (w < 1.0) {
                        maskL[df][k] = maskL[df][k] * (1 - w) + ml * w;
                        maskR[df][k] = maskR[df][k] * (1 - w) + mr * w;
                    } else {
                        maskL[df][k] = ml;
                        maskR[df][k] = mr;
                    }
                }
            }
            progressCb(42 + Math.round(((c + 1) / numChunks) * 28), LANG.ai_processing + ' (' + Math.round(((c + 1) / numChunks) * 100) + '%)');
            await yieldFrame();
        }

        // 4) Apply mask: instrumental_mag = mask * original_mag, vocal_mag = (1-mask) * original_mag
        progressCb(72, LANG.ai_reconstruct);
        await yieldFrame();
        var instrMagL = new Array(nf), instrMagR = new Array(nf);
        var vocalMagL = new Array(nf), vocalMagR = new Array(nf);
        for (var f = 0; f < nf; f++) {
            instrMagL[f] = new Float32Array(fb); instrMagR[f] = new Float32Array(fb);
            vocalMagL[f] = new Float32Array(fb); vocalMagR[f] = new Float32Array(fb);
            for (var k = 0; k < fb; k++) {
                instrMagL[f][k] = maskL[f][k] * stftL.mag[f][k];
                instrMagR[f][k] = maskR[f][k] * stftR.mag[f][k];
                vocalMagL[f][k] = (1 - maskL[f][k]) * stftL.mag[f][k];
                vocalMagR[f][k] = (1 - maskR[f][k]) * stftR.mag[f][k];
            }
        }

        // 5) iSTFT to reconstruct time-domain signals
        var instrL = aiISTFT(instrMagL, stftL.pRe, stftL.pIm, AI_NFFT, AI_HOP, len);
        await yieldFrame();
        var instrR = aiISTFT(instrMagR, stftR.pRe, stftR.pIm, AI_NFFT, AI_HOP, len);
        await yieldFrame();
        var vocalL = aiISTFT(vocalMagL, stftL.pRe, stftL.pIm, AI_NFFT, AI_HOP, len);
        await yieldFrame();
        var vocalR = aiISTFT(vocalMagR, stftR.pRe, stftR.pIm, AI_NFFT, AI_HOP, len);

        // 6) Build AudioBuffers
        var instrBuf = window.__safeAudioBuffer({ length: len, numberOfChannels: 2, sampleRate: sr });
        var vocalBuf = window.__safeAudioBuffer({ length: len, numberOfChannels: 2, sampleRate: sr });
        var iL = instrBuf.getChannelData(0), iR = instrBuf.getChannelData(1);
        var vL2 = vocalBuf.getChannelData(0), vR2 = vocalBuf.getChannelData(1);
        for (var i = 0; i < len; i++) {
            iL[i] = instrL[i]; iR[i] = instrR[i];
            vL2[i] = vocalL[i]; vR2[i] = vocalR[i];
        }
        return { instrumental: instrBuf, vocal: vocalBuf, mono: isMono };
    }

    // ── BPM Detection (shared module: /js/bpm-detector.js) ──
    function detectBPM(buffer) {
        var r = window.__detectBPM(buffer);
        return r ? r.bpm : 120;
    }

    // ── Key Detection ──
    function detectKey(buffer) {
        var data = buffer.getChannelData(0);
        var sr = buffer.sampleRate;
        var chroma = new Float32Array(12);
        var notes = ['C','C#','D','D#','E','F','F#','G','G#','A','A#','B'];

        for (var note = 0; note < 12; note++) {
            var sum = 0;
            for (var octave = 2; octave <= 6; octave++) {
                var freq = 440 * Math.pow(2, (note - 9) / 12 + (octave - 4));
                var period = sr / freq;
                var windowSize = Math.round(period * 4);
                if (windowSize > data.length) continue;
                var ac = 0, e = 0;
                var samples = Math.min(data.length, sr * 10);
                for (var i = 0; i < samples - windowSize; i += windowSize) {
                    var s = 0, es = 0;
                    for (var j = 0; j < windowSize; j++) {
                        s += data[i + j] * data[i + j + Math.round(period)];
                        es += data[i + j] * data[i + j];
                    }
                    ac += s; e += es;
                }
                sum += e > 0 ? ac / e : 0;
            }
            chroma[note] = sum;
        }

        var majorProfile = [6.35,2.23,3.48,2.33,4.38,4.09,2.52,5.19,2.39,3.66,2.29,2.88];
        var minorProfile = [6.33,2.68,3.52,5.38,2.60,3.53,2.54,4.75,3.98,2.69,3.34,3.17];
        var bestCorr = -Infinity, bestKey = 'C', bestMode = 'Major';

        for (var shift = 0; shift < 12; shift++) {
            var shifted = new Float32Array(12);
            for (var i = 0; i < 12; i++) shifted[i] = chroma[(i + shift) % 12];
            var mj = pearson(shifted, majorProfile);
            var mn = pearson(shifted, minorProfile);
            if (mj > bestCorr) { bestCorr = mj; bestKey = notes[shift]; bestMode = 'Major'; }
            if (mn > bestCorr) { bestCorr = mn; bestKey = notes[shift]; bestMode = 'Minor'; }
        }
        return bestKey + ' ' + bestMode;
    }

    function pearson(a, b) {
        var n = a.length, sa = 0, sb = 0;
        for (var i = 0; i < n; i++) { sa += a[i]; sb += b[i]; }
        var ma = sa / n, mb = sb / n;
        var num = 0, da = 0, db = 0;
        for (var i = 0; i < n; i++) {
            var x = a[i] - ma, y = b[i] - mb;
            num += x * y; da += x * x; db += y * y;
        }
        return num / (Math.sqrt(da * db) + 1e-20);
    }

    // ── Waveform Drawing ──
    function drawWaveform(canvas, buffer, color) {
        var dpr = window.devicePixelRatio || 1;
        var rect = canvas.parentElement.getBoundingClientRect();
        canvas.width = rect.width * dpr;
        canvas.height = rect.height * dpr;
        canvas.style.width = rect.width + 'px';
        canvas.style.height = rect.height + 'px';

        var ctx = canvas.getContext('2d');
        ctx.scale(dpr, dpr);
        ctx.clearRect(0, 0, rect.width, rect.height);

        var data = buffer.getChannelData(0);
        var step = data.length / rect.width;
        var mid = rect.height / 2;
        var amp = mid * 0.9;

        ctx.strokeStyle = color;
        ctx.lineWidth = 1;
        ctx.beginPath();
        for (var x = 0; x < rect.width; x++) {
            var start = Math.floor(x * step);
            var end = Math.floor((x + 1) * step);
            var min = 0, max = 0;
            for (var i = start; i < end && i < data.length; i++) {
                if (data[i] < min) min = data[i];
                if (data[i] > max) max = data[i];
            }
            ctx.moveTo(x + 0.5, mid + min * amp);
            ctx.lineTo(x + 0.5, mid + max * amp);
        }
        ctx.stroke();
    }

    // ── Process File ──
    async function processFile(file) {
        if (!file) return;
        var type = file.type || '';
        var ext = file.name.split('.').pop().toLowerCase();
        var validType = type.startsWith('audio/') || type === 'video/mp4' || type === 'video/webm';
        var validExt = ['mp3','wav','ogg','flac','aac','m4a','wma','aiff','opus','webm','mp4','3gp','caf'].indexOf(ext) >= 0;
        if (!validType && !validExt) {
            if (window.__toast) window.__reject(LANG.err_format || 'Unsupported file format', window.ToolErrors.REASONS.WRONG_FILE_TYPE);
            return;
        }

        // This file retires whatever the previous one still had in flight: its
        // placement (queued or running) and, below, the right to write its
        // separation result over this song.
        var myToken = curProcToken = {};
        cancelQueuedAutoSync(true);
        if (autoSyncAbort) { try { autoSyncAbort.abort(); } catch (_) {} }
        if (isPlaying) { try { stopPlayback(); } catch (_) {} }
        pauseOffset = 0;
        // The previous song's audio must not stand in for this one while it is
        // being prepared: the stage now works during that wait, and every check
        // there reads «is there audio yet» from musicBuffer.
        originalBuffer = musicBuffer = fullMusicBuffer = fullVocalBuffer = null;
        processedGuide = null; processedGuideToken = null;
        processedBuffer = null; processedToken = null; musicBufferGen++;
        var decodedResolve = null;
        decodedP = new Promise(function (r) { decodedResolve = r; });

        fileName = file.name.replace(/\.[^.]+$/, '');
        inputExt = file.name.split('.').pop().toLowerCase();
        songKey = songLyricsKey(file);
        // A timeline belongs to ONE file: never carry the previous song's times
        // onto this one's words.
        plainLrcLines = []; plainSyncSrc = ''; plainSyncedText = ''; untimedReported = false; stemEngine = '';
        loadSongLyrics();
        $upload.classList.add('collapsed');
        $processing.classList.add('active');
        $error.classList.remove('active');
        if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'process_start', mode: processingMode });
        // The workspace opens NOW, in its «voice not separated yet» form: the
        // words can go in, and be sent to the voice, while the voice is split.
        songPending = true;
        $fileName.textContent = file.name;
        $key.textContent = '--';
        $bpm.textContent = '--';
        $monoWarn.classList.remove('active');
        $result.classList.add('active', 'kr-pending');
        noteSongForLrcSearch(file);
        refreshPlainLyrics();

        try {
            if (!window.AudioContext && !window.webkitAudioContext) {
                throw new Error(LANG.err_browser);
            }
            // ONE AudioContext for the page's whole life. This used to be an
            // unconditional `new AudioContext()` on EVERY load — the mic chain
            // (micSource/micGain/reverb graph, module vars built in enableMic)
            // stayed on the PREVIOUS context, so after loading a second song
            // every startRecording/setReverbPreset connect() threw
            // InvalidAccessError "belonging to a different audio context"
            // (TIMBRICA-FRONTEND-CP/CQ), and each abandoned context also
            // leaked toward the browser's ~6-live-contexts cap. Recreate ONLY
            // from the 'closed' state (nothing closes this one today — video
            // export runs on its own local actx); a recreate orphans the mic
            // nodes, so rebuild that graph on the fresh context.
            if (!audioCtx || audioCtx.state === 'closed') {
                audioCtx = new (window.AudioContext || window.webkitAudioContext)();
                if (micEnabled && micStream) rebuildMicGraph();
            }

            // 1. Decode
            $procStep.textContent = LANG.step_decode;
            // A backing track only decodes — seconds. Separating the voice takes
            // minutes on most laptops, and «a few seconds» (what this line said
            // for every mode) was the promise #8273 waited out and gave up on;
            // what the wait is FOR goes here instead.
            $procSub.textContent = processingMode === 'instrumental' ? LANG.sub_wait : (LANG.sep_hint || LANG.sub_wait);
            $procFill.style.width = '10%';

            var arrayBuffer = await FileBytes.arrayBuffer(file);
            var decoded = await audioCtx.decodeAudioData(arrayBuffer);
            if (myToken !== curProcToken) return;        // a newer file took the page
            originalBuffer = decoded;
            decodedResolve();
            $timeTot.textContent = formatTime(originalBuffer.duration);
            if(window.ChannelModule) ChannelModule.detect(originalBuffer.numberOfChannels);
            $procFill.style.width = '20%';
            // Between the decode and the separator's first report the runtime and
            // the model load (~20 s): «Decoding audio» was shown for all of it.
            if (processingMode !== 'instrumental') $procStep.textContent = LANG.step_separate;

            // 2. Separate vocals — skipped entirely when the user already has
            //    a backing track ("instrumental" mode). In that case the upload
            //    IS the karaoke track and there is no vocal stem to blend.
            var separated = null;
            if (processingMode === 'instrumental') {
                fullMusicBuffer = musicBuffer = originalBuffer;
                musicBufferGen++;
                fullVocalBuffer = null;
                $procFill.style.width = '80%';
            } else {
                // Ultra (Kim_Vocal_2) — ТРЕБУЕТ СТЕРЕО: модель принимает
                // [1,4,3072,256] по двум каналам и на моно не запускается
                // вовсе. Поэтому моно сразу уходит на CascadedNet ниже, а не
                // падает с ошибкой.
                if (processingMode === 'ultra' && window.MdxStemSeparator
                    && originalBuffer.numberOfChannels >= 2) {
                    try {
                        stemEngine = 'kim';
                        separated = await window.MdxStemSeparator.split(originalBuffer, {
                            slug: 'karaoke',
                            // Третий аргумент несёт ФАКТИЧЕСКИЙ темп этой машины.
                            // Разброс между устройствами 25-кратный, предсказать
                            // его по таблице нельзя — показываем остаток по
                            // измеренному, а не по обещанному.
                            // Этап приходит кодом ('loading-model' / 'inference'),
                            // текст — из переводов: до 30.09.2026 модуль отдавал
                            // русские строки, и «Расчёт 3/11» стояло на любой локали.
                            onProgress: function(p, stage, t) {
                                var label = stage === 'loading-model'
                                    ? LANG.ai_loading
                                    : String(LANG.ai_processing || '').replace(/[\s.…]+$/, '') + ((t && t.total) ? ' · ' + t.chunks + '/' + t.total : '');
                                $procStep.textContent = (t && t.etaSec > 0)
                                    ? (label + ' · ~' + t.etaSec + 's') : label;
                                $procFill.style.width = Math.round(20 + p * 60) + '%';
                            }
                        });
                    } catch (ultraErr) {
                        console.warn('Ultra separation failed, falling back:', ultraErr);
                        separated = null;
                        stemEngine = '';
                    }
                }
                if (!separated && (processingMode === 'ai' || processingMode === 'ultra')) {
                    try {
                        stemEngine = 'cascaded';
                        separated = await aiSeparateVocals(originalBuffer, function(pct, msg) {
                            $procStep.textContent = msg;
                            $procFill.style.width = pct + '%';
                        });
                    } catch (aiErr) {
                        console.warn('AI separation failed, falling back to fast mode:', aiErr);
                        if (window.__toast) window.__toast(LANG.ai_fallback, 'warning');
                        $procStep.textContent = LANG.step_separate;
                        $procFill.style.width = '30%';
                        await new Promise(function(r) { setTimeout(r, 50); });
                        stemEngine = 'center';
                        separated = separateVocals(originalBuffer, 1.0);
                    }
                } else if (!separated) {
                    stemEngine = 'center';
                    $procStep.textContent = LANG.step_separate;
                    $procFill.style.width = '30%';
                    await new Promise(function(r) { setTimeout(r, 50); });
                    separated = separateVocals(originalBuffer, 1.0);
                }
                // A newer file took the page while this one was being split.
                if (myToken !== curProcToken) return;
                fullMusicBuffer = separated.instrumental;
                fullVocalBuffer = separated.vocal;

                // The backing is the song minus the whole vocal; the guide plays
                // beside it at the slider's level (startGuide).
                buildBacking();
                $procFill.style.width = '80%';
            }

            // 3. Analyze
            $procStep.textContent = LANG.step_analyze;
            $procFill.style.width = '85%';
            await new Promise(function(r) { setTimeout(r, 30); });

            detectedBPM = detectBPM(originalBuffer);
            var detectedKey = detectKey(originalBuffer);
            $procFill.style.width = '95%';

            // 4. Display results
            $procStep.textContent = LANG.step_done;
            $procFill.style.width = '100%';

            $fileName.textContent = file.name;
            $key.textContent = detectedKey;
            $bpm.textContent = detectedBPM;
            $timeTot.textContent = formatTime(originalBuffer.duration);

            // Mono warning is separation-specific (a mono source can't be split).
            // Instrumental mode never separates, so it never warns.
            if (separated && separated.mono) {
                $monoWarn.classList.add('active');
            } else {
                $monoWarn.classList.remove('active');
            }

            // Vocal Guide blends the separated vocal stem back in — meaningless
            // when there is no stem, so hide it for instrumental uploads.
            if ($guidePanel) {
                $guidePanel.style.display = (processingMode === 'instrumental') ? 'none' : '';
            }

            // Show mic section if supported
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                $mic.classList.remove('hidden');
            }

            // Auto-detect output format from input (via centralized FormatSmart)
            outputFormat = FormatSmart.selectOption(FormatSmart.mapFormat(inputExt, FormatSmart.getAvailable('#krFormatSelect')), '#krFormatSelect');
            if(FormatSmart.upgradeControl) FormatSmart.upgradeControl(file, {select:'#krFormatSelect'}, outputFormat);
            // FormatSmart just set the <select> programmatically — that fires no
            // 'change' event, so the handler never runs and the module would keep
            // the stale format (a WAV upload would lose its legitimate 5.1 option).
            if(window.ChannelModule) ChannelModule.updateForFormat(outputFormat);
            $sourceBadge.textContent = '⬆ ' + inputExt.toUpperCase();
            updateQualityVisibility();

            await new Promise(function(r) { setTimeout(r, 300); });
            if (myToken !== curProcToken) return;
            $processing.classList.remove('active');
            songPending = false;
            $result.classList.remove('kr-pending');
            $result.classList.add('active');
            document.getElementById('workspace-placeholder')?.classList.add('hidden');
            // iOS Safari records no video/webm at all, so the karaoke-video
            // block cannot work there. It used to be offered anyway and only
            // failed AFTER the click — hide it up front instead of promising
            // a button that is guaranteed to error.
            var $veBox = document.getElementById('krVideoExport');
            if ($veBox && window.KaraokeVideoExport && !window.KaraokeVideoExport.isAvailable()) {
                $veBox.style.display = 'none';
                if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'video_export_unsupported' });
            }
            // Restore a saved tuning for this exact track, then work out whether
            // its vocal sits in the singer's measured range. Both are additive —
            // if there is nothing saved and no measurement, nothing appears.
            try { applyPendingSong(); } catch (_) {}
            computeKeyFit();
            if (window.__ae) window.__ae('feature_use', {
                slug: 'karaoke', f: 'process_done', mode: processingMode,
                bpm: detectedBPM, mono: separated ? !!separated.mono : false,
            });

            // Draw waveform AFTER element is visible so canvas has correct dimensions
            // Words sent to the voice during the separation go there now — not
            // from the frame callback below: a separation of minutes is exactly
            // when people switch tabs, and a hidden tab runs no frames.
            startQueuedAutoSync();

            requestAnimationFrame(function() {
                drawWaveform($canvas, musicBuffer, '#38bdf8');
                // Words typed before the track was ready: say where they stand
                // (restored timing, or untimed) — never invent times for them.
                refreshPlainLyrics();
            });

        } catch (err) {
            if (myToken !== curProcToken) return;        // a newer file owns the page
            console.error('Karaoke error:', err);
            if (decodedResolve) decodedResolve();
            songPending = false;
            cancelQueuedAutoSync(true);
            $result.classList.remove('active', 'kr-pending');
            setSyncFace(null);
            $processing.classList.remove('active');
            $error.textContent = LANG.err_decode;
            $error.classList.add('active');
            $upload.classList.remove('collapsed');
            if (window.__toast) window.__toast(LANG.err_decode, 'error');
        }
    }

    // ── Screen Wake Lock ──
    // A 4-minute sing-along must not let the screen sleep. The lock is released
    // on pause/stop/end and re-acquired if the tab regains visibility mid-song.
    var wakeLock = null;
    function acquireWakeLock() {
        if (wakeLock || !navigator.wakeLock) return;
        navigator.wakeLock.request('screen').then(function(s) {
            wakeLock = s;
            wakeLock.addEventListener('release', function() { wakeLock = null; });
        }).catch(function() { /* policy / unsupported — non-fatal */ });
    }
    function releaseWakeLock() {
        if (wakeLock) { try { wakeLock.release(); } catch (e) {} wakeLock = null; }
    }
    document.addEventListener('visibilitychange', function() {
        if (document.visibilityState === 'visible' && isPlaying) acquireWakeLock();
    });

    // ── Playback ──
    function startPlayback() {
        if (!musicBuffer || !audioCtx) return;
        acquireWakeLock();

        karaokeSource = audioCtx.createBufferSource();
        // Key/tempo are already baked into this buffer (ensureProcessedBuffer),
        // so it plays untouched at 1.0× — that is what keeps `elapsed` equal to
        // wall time and the lyrics in sync. Never set playbackRate/detune here.
        karaokeSource.buffer = playbackBuffer();

        karaokeGain = audioCtx.createGain();
        karaokeGain.gain.value = 1.0;
        karaokeSource.connect(karaokeGain);
        karaokeGain.connect(audioCtx.destination);

        // Connect to mix destination if recording (through the latency delay)
        if (isRecording && mixDestination) {
            var mt = backingMixTarget();
            if (mt) karaokeGain.connect(mt);
        }

        // One `when` for the backing and the guide: two sources started at the
        // same context time stay sample-locked for the whole song.
        var when = audioCtx.currentTime;
        startTime = when - pauseOffset;
        karaokeSource.start(when, pauseOffset);
        startGuide(when, pauseOffset);

        karaokeSource.onended = function() {
            stopGuide();
            if (isPlaying) {
                isPlaying = false;
                pauseOffset = 0;
                $playBtn.classList.remove('playing');
                $cursor.style.left = '0';
                $timeCur.textContent = '0:00';
                cancelAnimationFrame(animFrame);
                releaseWakeLock();
                finishScoring();
            }
        };

        // A from-the-top start begins a fresh scoring session.
        if (scoringEnabled && (!scorer || pauseOffset < 0.5)) resetScorer();

        isPlaying = true;
        $playBtn.classList.add('playing');
        updateCursor();
    }

    function stopPlayback(keepOffset) {
        if (karaokeSource) {
            karaokeSource.onended = null;
            try { karaokeSource.stop(); } catch(e) {}
            karaokeSource = null;
        }
        stopGuide();
        if (isPlaying && !keepOffset) {
            var elapsed = audioCtx.currentTime - startTime;
            pauseOffset = Math.min(elapsed, playbackDuration());
        }
        isPlaying = false;
        $playBtn.classList.remove('playing');
        cancelAnimationFrame(animFrame);
        releaseWakeLock();
        if (countInRunning) cancelCountIn();
    }

    function togglePlay() {
        if (!audioCtx) return;
        if (audioCtx.state === 'suspended') audioCtx.resume();
        if (isPlaying) {
            stopPlayback();
        } else if (countInRunning) {
            // second press during count-in = skip the countdown
            finishCountIn();
        } else if (pauseOffset < 0.5 && hasLyricsTimeline()) {
            // Starting a sing-along from the top — give the singer a count-in.
            runCountIn(startPlayback);
        } else {
            startPlayback();
        }
    }

    function updateCursor() {
        if (!isPlaying || !musicBuffer) return;
        var elapsed = audioCtx.currentTime - startTime;
        var duration = playbackDuration();

        // A-B Loop check — use setTimeout to break call stack
        if (loopEnabled && loopA !== null && loopB !== null && elapsed >= loopB) {
            pauseOffset = loopA;
            stopPlayback();
            setTimeout(startPlayback, 0);
            return;
        }

        if (elapsed >= duration) {
            isPlaying = false;
            pauseOffset = 0;
            $playBtn.classList.remove('playing');
            $cursor.style.left = '0';
            $timeCur.textContent = '0:00';
            releaseWakeLock();
            finishScoring();
            return;
        }
        var pct = elapsed / duration;
        pxWrite($cursor, 'left', pct * 100);
        textWrite($timeCur, formatTime(elapsed));

        // Lyrics, scoring and the fullscreen mirror all index timelines built in
        // ORIGINAL song seconds, so they get song time, not playback time.
        var songT = toSongTime(elapsed);
        // LRC highlight
        if (lrcActive && lrcLines.length > 0) {
            updateLRCHighlight(songT);
        }
        // Plain text karaoke highlight
        if (plainLrcActive && plainLrcLines.length > 0 && lyricsMode === 'plain') {
            updatePlainLyricsHighlight(songT);
        }
        // Fullscreen sing-along mirror
        if (fsActive) updateFullscreen(songT);
        // Pitch scoring — sample the live mic against the reference melody
        if (scoringEnabled) scoringTick(songT);

        animFrame = requestAnimationFrame(updateCursor);
    }

    $playBtn.addEventListener('click', togglePlay);

    // ═══════════════════════════════════════
    // Fullscreen sing-along + count-in
    // ═══════════════════════════════════════
    var $fsBtn = document.getElementById('krFsBtn');
    var $fullscreen = document.getElementById('krFullscreen');
    var $fsClose = document.getElementById('krFsClose');
    var $fsLyrics = document.getElementById('krFsLyrics');
    var $fsPlay = document.getElementById('krFsPlay');
    var $fsTimeCur = document.getElementById('krFsTimeCur');
    var $fsTimeTot = document.getElementById('krFsTimeTot');
    var $countin = document.getElementById('krCountin');
    var $countinNum = document.getElementById('krCountinNum');
    var fsActive = false;
    var countInRunning = false;
    var countInTimer = null;
    var countInDone = null;

    // The lyric timeline for whichever lyrics mode is currently active.
    function activeTimeline() {
        if (lyricsMode === 'lrc' && lrcActive && lrcLines.length) return lrcLines;
        if (plainLrcActive && plainLrcLines.length) return plainLrcLines;
        return [];
    }
    function hasLyricsTimeline() { return activeTimeline().length > 0; }

    /** @param songT position in ORIGINAL song seconds (the timeline's base). */
    function updateFullscreen(songT) {
        if (window.KaraokeLyrics) {
            window.KaraokeLyrics.update($fsLyrics, activeTimeline(), songT);
        }
        // The readout is a clock, so it shows PLAYBACK time — the same number
        // as the main transport and the same base as $fsTimeTot.
        $fsTimeCur.textContent = formatTime(toPlaybackTime(songT));
        $fsPlay.classList.toggle('playing', isPlaying);
    }

    function openFullscreen() {
        var tl = activeTimeline();
        if (tl.length && window.KaraokeLyrics) {
            window.KaraokeLyrics.render($fsLyrics, tl, { onSeek: seekToTime });
        } else if (lyricsMode === 'plain' && plainLines().length) {
            // Words without times: show them ALL, unlit and scrollable. Lighting
            // a line we cannot place would scroll the right one off the screen.
            $fsLyrics.innerHTML = '';
            plainLines().forEach(function (t) {
                var d = document.createElement('div');
                d.className = 'kr-lrc-line upcoming';
                d.textContent = t;
                $fsLyrics.appendChild(d);
            });
        } else {
            $fsLyrics.innerHTML = '<div class="kr-fs-empty">' + (LANG.fullscreen_empty || '') + '</div>';
        }
        $fsTimeTot.textContent = musicBuffer ? formatTime(playbackDuration()) : '0:00';
        $fsTimeCur.textContent = formatTime(pauseOffset);
        $fsPlay.classList.toggle('playing', isPlaying);
        fsActive = true;
        $fullscreen.classList.add('active');
        if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'fullscreen_open' });
        if ($fullscreen.requestFullscreen) {
            $fullscreen.requestFullscreen().catch(function () { /* policy — overlay still shows */ });
        }
    }
    function closeFullscreen() {
        fsActive = false;
        $fullscreen.classList.remove('active');
        if (document.fullscreenElement) {
            try { document.exitFullscreen(); } catch (e) {}
        }
    }
    if ($fsBtn) $fsBtn.addEventListener('click', openFullscreen);
    if ($fsClose) $fsClose.addEventListener('click', closeFullscreen);
    if ($fsPlay) $fsPlay.addEventListener('click', togglePlay);
    document.addEventListener('fullscreenchange', function () {
        // User pressed Esc / browser-exited fullscreen — keep overlay state in sync.
        if (!document.fullscreenElement && fsActive) {
            fsActive = false;
            $fullscreen.classList.remove('active');
        }
    });

    // ── Count-in: 4 beats on the detected BPM before a from-the-top start ──
    function clearCountIn() {
        if (countInTimer) { clearTimeout(countInTimer); countInTimer = null; }
        countInRunning = false;
        if ($countin) $countin.classList.remove('active');
    }
    function finishCountIn() {           // skip the countdown → start playing
        clearCountIn();
        var cb = countInDone; countInDone = null;
        if (cb) cb();
    }
    function cancelCountIn() {           // abort the countdown → do NOT play
        clearCountIn();
        countInDone = null;
    }
    function runCountIn(done) {
        countInRunning = true;
        countInDone = done;
        var beatMs = detectedBPM > 0 ? Math.round(60000 / detectedBPM) : 600;
        // clamp so a very slow/fast BPM still feels like a count-in
        beatMs = Math.max(350, Math.min(900, beatMs));
        var n = 4;
        $countin.classList.add('active');
        var tick = function () {
            if (!countInRunning) return;
            if (n <= 0) { finishCountIn(); return; }
            $countinNum.textContent = n;
            // restart the pulse animation
            $countinNum.style.animation = 'none';
            void $countinNum.offsetWidth;
            $countinNum.style.animation = '';
            n--;
            countInTimer = setTimeout(tick, beatMs);
        };
        tick();
    }
    // Tapping the countdown skips straight to playback.
    if ($countin) $countin.addEventListener('click', finishCountIn);

    // ── Reading-friendly (dyslexia) lyrics mode (Phase 9) ──
    var $a11yBtn = document.getElementById('krA11yBtn');
    var $krApp = document.querySelector('.kr-app');
    if ($a11yBtn && $krApp) {
        var a11yOn = window.__toolSettings
            ? window.__toolSettings.load('karaoke', 'a11y_dyslexia', false) : false;
        var applyA11y = function (on) {
            $krApp.classList.toggle('kr-a11y', !!on);
            $a11yBtn.classList.toggle('on', !!on);
        };
        applyA11y(a11yOn);
        $a11yBtn.addEventListener('click', function () {
            a11yOn = !a11yOn;
            applyA11y(a11yOn);
            if (window.__toolSettings) window.__toolSettings.save('karaoke', 'a11y_dyslexia', a11yOn);
            if (window.__announce) window.__announce(a11yOn ? (LANG.a11y_on || '') : (LANG.a11y_off || ''));
            if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'a11y_dyslexia', on: a11yOn });
        });
    }

    // ── Waveform seek ──
    var $waveWrap = document.getElementById('krWave');
    function seekTo(clientX) {
        if (!musicBuffer) return;
        var rect = $waveWrap.getBoundingClientRect();
        var pct = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
        var wasPlaying = isPlaying;
        if (isPlaying) stopPlayback(true);
        pauseOffset = pct * playbackDuration();
        pxWrite($cursor, 'left', pct * 100);
        textWrite($timeCur, formatTime(pauseOffset));
        if (wasPlaying) startPlayback();
    }
    $waveWrap.addEventListener('click', function(e) { seekTo(e.clientX); });
    $waveWrap.addEventListener('touchstart', function(e) { e.preventDefault(); seekTo(e.touches[0].clientX); });

    // ── Vocal Guide slider ──
    // A gain move, heard at once; the backing is never re-rendered for it (it
    // used to be: every move rebuilt the mix and, under a key or tempo change,
    // re-ran the whole stretch).
    var vocalGuideTimeout, vocalGuideTelemetry;
    $guideSlider.addEventListener('input', function() {
        vocalGuide = Math.max(0, Math.min(100, parseInt(this.value, 10) || 0));
        $guideVal.textContent = vocalGuide + '%';
        if (guideGain) guideGain.gain.value = guideLevel();
        clearTimeout(vocalGuideTimeout);
        vocalGuideTimeout = setTimeout(syncGuideSource, 150);
        clearTimeout(vocalGuideTelemetry);
        vocalGuideTelemetry = setTimeout(function () {
            if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'guide_change', value: vocalGuide });
        }, 2000);
    });
    /* Bring the playing graph in line with the slider: off → drop the guide
       source; on → render it for the current key/tempo if needed and join the
       running backing at the same moment (the backing is not restarted). */
    var guideSyncRun = 0;
    async function syncGuideSource() {
        var run = ++guideSyncRun;
        if (vocalGuide <= 0 || !guideFitsTheSong()) { stopGuide(); return; }
        if (!guidePlaybackBuffer()) {
            shiftStatus(true, 0);
            try {
                await ensureProcessedGuide();
            } catch (e) {
                if (window.__handleError) window.__handleError(e, 'karaoke:guide-render');
            } finally {
                shiftStatus(false);
            }
            if (run !== guideSyncRun) return;   // the slider moved on meanwhile
        }
        if (isPlaying && !guideSource) startGuide(audioCtx.currentTime, getCurrentElapsed());
    }

    /* ── Applying key/tempo ───────────────────────────────────────────────────
     * A shift is now a real render (AudioPipeline.stretch), not a node property,
     * so it is debounced: dragging a slider fires `input` per pixel and we want
     * one stretch on release, not sixty. Labels and the total-time readout still
     * update on every `input`, so the control feels immediate. */
    var keyTempoApplyTimer = null;
    var keyTempoPrevTempo = null;   // tempo in force when the pending drag began
    // Last key/tempo that actually got rendered — what the sliders roll back to
    // if a render is refused, so they never advertise a shift that is not playing.
    var appliedKey = 0;
    var appliedTempo = 1.0;

    function renderKeyLabel() {
        if (!$keyVal) return;
        $keyVal.textContent = currentKey === 0
            ? LANG.key_original
            : (currentKey > 0 ? '+' : '') + currentKey + ' ' + LANG.key_semitones;
    }
    function renderTempoLabel() {
        if (!$tempoVal) return;
        if (currentTempo === 1.0) { $tempoVal.textContent = LANG.tempo_original; return; }
        var pct = Math.round(currentTempo * 100);
        var adjBpm = detectedBPM ? Math.round(detectedBPM * currentTempo) : '';
        $tempoVal.textContent = pct + '%' + (adjBpm ? ' (' + adjBpm + ' BPM)' : '');
    }

    function refreshTransportTotals() {
        if (!musicBuffer) return;
        var d = playbackDuration();
        $timeTot.textContent = formatTime(d);
        if ($fsTimeTot) $fsTimeTot.textContent = formatTime(d);
    }

    async function applyKeyTempo(prevTempo) {
        if (!musicBuffer) return;
        var wasPlaying = isPlaying;
        // Anchor the position in ORIGINAL song seconds — that survives a tempo
        // change, where the playback time base itself is what moved.
        var songPos = getCurrentElapsed() * (prevTempo || currentTempo);
        if (isPlaying) stopPlayback(true);

        $keySlider.disabled = true;
        $tempoSlider.disabled = true;
        shiftStatus(true, 0);
        var failed = false;
        try {
            await ensureProcessedBuffer();
            appliedKey = currentKey;
            appliedTempo = currentTempo;
            // The guide follows the shift only while it is on. Its render
            // failing must not undo the backing's shift: the song plays without
            // the guide and the error is said once.
            if (vocalGuide > 0) {
                try { await ensureProcessedGuide(); }
                catch (ge) { if (window.__handleError) window.__handleError(ge, 'karaoke:guide-render'); }
            }
        } catch (e) {
            /* AudioPipeline refuses up front when the predicted peak would OOM
               the device (typed AUDIO_TOO_LARGE). Leaving the sliders parked on
               a shift we did not apply would make the UI lie about what is
               playing — so roll them back to the last shift that really landed
               and let the error speak. */
            failed = true;
            processedBuffer = null; processedToken = null;
            if (window.__handleError) window.__handleError(e, 'karaoke:key-tempo');
        } finally {
            $keySlider.disabled = false;
            $tempoSlider.disabled = false;
            shiftStatus(false);
        }
        if (failed) {
            currentKey = appliedKey;
            currentTempo = appliedTempo;
            if ($keySlider) $keySlider.value = String(currentKey);
            if ($tempoSlider) $tempoSlider.value = String(Math.round(currentTempo * 100));
            renderKeyLabel();
            renderTempoLabel();
        }

        pauseOffset = Math.max(0, Math.min(toPlaybackTime(songPos), playbackDuration()));
        refreshTransportTotals();
        updateLoopVisuals();
        if (wasPlaying) startPlayback();
        else {
            var d = playbackDuration();
            if (d > 0) pxWrite($cursor, 'left', (pauseOffset / d) * 100);
            textWrite($timeCur, formatTime(pauseOffset));
        }
    }

    function scheduleKeyTempoApply(prevTempo) {
        if (keyTempoPrevTempo === null) keyTempoPrevTempo = prevTempo;
        clearTimeout(keyTempoApplyTimer);
        keyTempoApplyTimer = setTimeout(function () {
            var p = keyTempoPrevTempo;
            keyTempoPrevTempo = null;
            applyKeyTempo(p);
        }, 220);
    }

    // ── Key Change slider ──
    $keySlider.addEventListener('input', function() {
        currentKey = parseInt(this.value);
        renderKeyLabel();
        // Key is pitch-only now, so the duration readout does not move.
        scheduleKeyTempoApply(currentTempo);
        // Debounced: a drag fires `input` per pixel, and transposing to fit
        // your range is the tool's differentiator — worth one event, not sixty.
        clearTimeout(keyTempoTimeout);
        keyTempoTimeout = setTimeout(function() {
            if (window.__ae && currentKey !== 0) {
                window.__ae('feature_use', { slug: 'karaoke', f: 'key_change', semitones: currentKey });
            }
        }, 2000);
    });

    // ── Tempo slider ──
    $tempoSlider.addEventListener('input', function() {
        var prevTempo = currentTempo;
        currentTempo = parseInt(this.value) / 100;
        renderTempoLabel();
        // The stretch lands on exactly duration/rate, so the readout can move
        // now and still be right when the render finishes.
        if (musicBuffer) {
            $timeTot.textContent = formatTime(musicBuffer.duration / currentTempo);
        }
        scheduleKeyTempoApply(prevTempo);
        clearTimeout(tempoTelemetryTimeout);
        tempoTelemetryTimeout = setTimeout(function() {
            if (window.__ae && currentTempo !== 1.0) {
                window.__ae('feature_use', { slug: 'karaoke', f: 'tempo_change', pct: Math.round(currentTempo * 100) });
            }
        }, 2000);
    });

    // ── Format selector ──
    function updateQualityVisibility() {
        var isLossless = outputFormat === 'wav' || outputFormat === 'flac';
        $qualitySel.classList.toggle('hidden', isLossless);
    }
    if ($formatSelect) $formatSelect.addEventListener('change', function() {
        outputFormat = this.value;
        updateQualityVisibility();
        if(window.ChannelModule) ChannelModule.updateForFormat(outputFormat);
    });

    // ── Quality selector ──
    if ($qualitySelect) $qualitySelect.addEventListener('change', function() {
        outputQuality = this.value;
    });

    // ── Stop button (reset to beginning) ──
    $stopBtn.addEventListener('click', function() {
        if (isPlaying) stopPlayback(true);
        pauseOffset = 0;
        $cursor.style.left = '0';
        $timeCur.textContent = '0:00';
        $playBtn.classList.remove('playing');
    });

    // ── Download ──
    $download.addEventListener('click', async function() {
        if (!musicBuffer) return;
        $download.disabled = true;
        var origText = $download.innerHTML;

        try {
            var rendered = await renderExportBuffer();

            $download.innerHTML = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3"/></svg> ' + LANG.encoding + '...';

            var wavBlob = audioBufferToWav(rendered);

            if (outputFormat === 'wav') {
                triggerDownload(wavBlob, fileName + '-karaoke.wav');
            } else {
                if (!window.FFmpegProcessor) {
                    triggerDownload(wavBlob, fileName + '-karaoke.wav');
                    return;
                }
                var codecMap = {
                    mp3:  ['-c:a', 'libmp3lame', '-b:a', outputQuality + 'k'],
                    flac: ['-c:a', 'flac'],
                    ogg:  ['-c:a', 'libvorbis', '-b:a', outputQuality + 'k'],
                    opus: ['-c:a', 'libopus', '-b:a', outputQuality + 'k']
                };
                var codec = (codecMap[outputFormat] || codecMap.mp3).concat(window.ChannelModule ? ChannelModule.getArgs() : []);
                var ext = outputFormat;
                var outFile = outputFormat === 'opus' ? 'output.ogg' : 'output.' + ext;
                var wavFile = new File([wavBlob], 'input.wav', { type: 'audio/wav' });
                var result = await FFmpegProcessor.process(wavFile, codec, outFile);
                triggerDownload(result.blob, fileName + '-karaoke.' + ext);
            }
            // The conversion metric for the "I just want the backing track"
            // half of the audience — previously invisible, which made it
            // impossible to tell that half apart from the people who sing.
            if (window.__ae) window.__ae('feature_use', {
                slug: 'karaoke', f: 'download_karaoke', fmt: outputFormat,
                q: outputQuality, key: currentKey, tempo: Math.round(currentTempo * 100),
                guide: vocalGuide, sang: micEnabled ? 1 : 0,
            });
        } catch (err) {
            console.error('Download error:', err);
            if (window.__toast) window.__toast(LANG.err_decode, 'error');
            if (window.__ae) window.__ae('feature_use', {
                slug: 'karaoke', f: 'download_failed', fmt: outputFormat,
            });
        } finally {
            $download.disabled = false;
            $download.innerHTML = origText;
        }
    });

    /* The downloaded backing track is the key/tempo render the user has been
       singing to (renderExportBuffer — plus the guide, if it is on). It used to
       be re-derived with the same broken playbackRate+detune pair as playback,
       which additionally sized the render as length/tempo — so a 150 % tempo
       handed back a file cut to 67 % of the song. */

    // ── WAV Encoder ──
    function audioBufferToWav(buffer) {
        var numCh = buffer.numberOfChannels;
        var sr = buffer.sampleRate;
        var len = buffer.length;
        var bytesPerSample = 2;
        var blockAlign = numCh * bytesPerSample;
        var dataSize = len * blockAlign;
        var buf = new ArrayBuffer(44 + dataSize);
        var view = new DataView(buf);

        writeStr(view, 0, 'RIFF');
        view.setUint32(4, 36 + dataSize, true);
        writeStr(view, 8, 'WAVE');
        writeStr(view, 12, 'fmt ');
        view.setUint32(16, 16, true);
        view.setUint16(20, 1, true);
        view.setUint16(22, numCh, true);
        view.setUint32(24, sr, true);
        view.setUint32(28, sr * blockAlign, true);
        view.setUint16(32, blockAlign, true);
        view.setUint16(34, bytesPerSample * 8, true);
        writeStr(view, 36, 'data');
        view.setUint32(40, dataSize, true);

        var channels = [];
        for (var c = 0; c < numCh; c++) channels.push(buffer.getChannelData(c));

        var offset = 44;
        for (var i = 0; i < len; i++) {
            for (var c = 0; c < numCh; c++) {
                var sample = Math.max(-1, Math.min(1, channels[c][i]));
                view.setInt16(offset, sample < 0 ? sample * 0x8000 : sample * 0x7FFF, true);
                offset += 2;
            }
        }
        return new Blob([buf], { type: 'audio/wav' });
    }

    function writeStr(view, offset, str) {
        for (var i = 0; i < str.length; i++) view.setUint8(offset + i, str.charCodeAt(i));
    }

    function triggerDownload(blob, name) {
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url; a.download = name; a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        setTimeout(function() { document.body.removeChild(a); URL.revokeObjectURL(url); }, 100);
        try{window.__aeToolComplete({file:name,sizeMB:Math.round(blob.size/1048576)})}catch(e){}
    }

    // ═══════════════════════════════════════
    // MODULE 1: Microphone + Reverb
    // ═══════════════════════════════════════

    function generateIR(duration, decay) {
        if (!audioCtx) return null;
        var key = duration + '_' + decay;
        if (irBuffers[key]) return irBuffers[key];
        var sr = audioCtx.sampleRate;
        var len = Math.round(sr * duration);
        var buf = audioCtx.createBuffer(2, len, sr);
        for (var ch = 0; ch < 2; ch++) {
            var data = buf.getChannelData(ch);
            for (var i = 0; i < len; i++) {
                data[i] = (Math.random() * 2 - 1) * Math.exp(-decay * i / len);
            }
        }
        irBuffers[key] = buf;
        return buf;
    }

    function disconnectReverb() {
        if (reverbNode) { try { reverbNode.disconnect(); } catch(e) {} reverbNode = null; }
        if (reverbWetGain) { try { reverbWetGain.disconnect(); } catch(e) {} reverbWetGain = null; }
        if (reverbDryGain) { try { reverbDryGain.disconnect(); } catch(e) {} reverbDryGain = null; }
        if (echoDelay) { try { echoDelay.disconnect(); } catch(e) {} echoDelay = null; }
        if (echoFeedback) { try { echoFeedback.disconnect(); } catch(e) {} echoFeedback = null; }
    }

    function setReverbPreset(name) {
        if (!audioCtx || !micGain) return;
        currentReverb = name;
        disconnectReverb();

        if (name === 'off') {
            micGain.connect(micBus);
            return;
        }

        reverbDryGain = audioCtx.createGain();
        reverbWetGain = audioCtx.createGain();

        var presets = {
            room:      { dur: 0.4, decay: 2.5, dry: 0.7, wet: 0.3 },
            hall:      { dur: 1.8, decay: 3.5, dry: 0.5, wet: 0.5 },
            cathedral: { dur: 3.5, decay: 5.0, dry: 0.4, wet: 0.6 }
        };

        if (name === 'echo') {
            reverbDryGain.gain.value = 0.6;
            reverbWetGain.gain.value = 0.4;
            micGain.connect(reverbDryGain);
            echoDelay = audioCtx.createDelay(1.0);
            echoDelay.delayTime.value = 0.35;
            echoFeedback = audioCtx.createGain();
            echoFeedback.gain.value = 0.35;
            micGain.connect(echoDelay);
            echoDelay.connect(echoFeedback);
            echoFeedback.connect(echoDelay);
            echoDelay.connect(reverbWetGain);
        } else {
            var p = presets[name];
            reverbDryGain.gain.value = p.dry;
            reverbWetGain.gain.value = p.wet;
            micGain.connect(reverbDryGain);
            reverbNode = audioCtx.createConvolver();
            reverbNode.buffer = generateIR(p.dur, p.decay);
            micGain.connect(reverbNode);
            reverbNode.connect(reverbWetGain);
        }

        reverbDryGain.connect(micBus);
        reverbWetGain.connect(micBus);
    }

    // (Re)build the mic node graph on the CURRENT audioCtx from the live
    // micStream. Shared by enableMic() and the closed-context recovery in
    // processFile() — a MediaStream is context-independent, so rebuilding
    // never re-prompts for permission.
    function buildMicGraph() {
        micSource = audioCtx.createMediaStreamSource(micStream);
        micGain = audioCtx.createGain();
        micGain.gain.value = parseInt($micVol.value) / 100;
        micBus = audioCtx.createGain();
        micBus.gain.value = 1;
        if (isRecording && mixDestination) { try { micBus.connect(mixDestination); } catch (e) {} }
        micAnalyser = audioCtx.createAnalyser();
        // 2048 samples — large enough for the time-domain autocorrelation
        // pitch detector (Phase 7 scoring); the level meter works at any size.
        micAnalyser.fftSize = 2048;

        micSource.connect(micGain);
        micSource.connect(micAnalyser);

        setReverbPreset(currentReverb);

        if (window.MicMonitor) {
            try {
                micMonitor = MicMonitor.attach(audioCtx, { tool: 'karaoke', source: micBus, mount: $monitorSlot, hintMount: $monitorSlot && $monitorSlot.parentNode, labels: monitorLabels() });
            } catch (e) { micMonitor = null; }
        }
    }

    function tearDownMicBus() {
        if (micMonitor) { try { micMonitor.detach(); } catch (e) {} micMonitor = null; }
        if (micBus) { try { micBus.disconnect(); } catch (e) {} micBus = null; }
    }

    // Closed-context recovery: drop node refs that died with the old context
    // (disconnect is best-effort — nodes of a closed context are inert) and
    // rebuild on the fresh one.
    function rebuildMicGraph() {
        tearDownMicBus();
        if (micSource) { try { micSource.disconnect(); } catch (e) {} }
        if (micGain) { try { micGain.disconnect(); } catch (e) {} }
        if (micAnalyser) { try { micAnalyser.disconnect(); } catch (e) {} }
        disconnectReverb();
        mixDestination = null; // belonged to the dead context
        mixDelay = null;
        buildMicGraph();
    }

    async function enableMic() {
        if (!audioCtx) return;
        if (audioCtx.state === 'suspended') await audioCtx.resume();
        try {
            if(!window._krMic) window._krMic = new MicManager();
            // HI-FI vocal capture — feedback #1026 class (2026-07-17 «звук как
            // на диктофон»). The voice DSP (echoCancellation/noiseSuppression/
            // autoGainControl) is TUNED FOR SPEECH and wrecks a sung take: AGC
            // pumps the level, NS gates sustained notes + breath, EC comb-
            // filters. Disable all three so the karaoke vocal records clean and
            // dynamic — same no-DSP capture the sibling music-recording tools
            // (recording-studio, vocal, multi-track) already use.
            micStream = await window._krMic.start({echoCancellation:false,noiseSuppression:false,autoGainControl:false});
        } catch (err) {
            if (window.__toast) window.__toast(err.message, 'error');
            // A refused/absent mic ends the karaoke path entirely, so it needs
            // to be visible in the funnel next to mic_enabled.
            if (window.__ae) window.__ae('feature_use', {
                slug: 'karaoke', f: 'mic_blocked',
                reason: String((err && err.name) || 'unknown').slice(0, 24),
            });
            return;
        }

        // The permission sheet can suspend the context while it is up (the
        // megaphone class: user activation dies behind the system prompt) —
        // resume AFTER the grant too, or the meter/monitoring stays silent.
        if (audioCtx.state === 'suspended') { try { await audioCtx.resume(); } catch (e) {} }

        buildMicGraph();

        micEnabled = true;
        $mic.classList.add('enabled');
        $micToggle.classList.add('on');
        $micToggle.textContent = LANG.mic_disable;

        // Singing is the whole product; until now nothing recorded whether
        // anyone ever got the mic on, so "is this a karaoke tool or a backing-
        // track downloader?" had no answer in the data.
        if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'mic_enabled' });

        drawMicMeter();
    }

    function disableMic() {
        if (isRecording) stopRecording();
        if (micStream) {
            micStream.getTracks().forEach(function(t) { t.stop(); });
            micStream = null;
        }
        tearDownMicBus();
        if (micSource) { try { micSource.disconnect(); } catch(e) {} micSource = null; }
        if (micGain) { try { micGain.disconnect(); } catch(e) {} micGain = null; }
        if (micAnalyser) { try { micAnalyser.disconnect(); } catch(e) {} micAnalyser = null; }
        disconnectReverb();

        micEnabled = false;
        $mic.classList.remove('enabled');
        $micToggle.classList.remove('on');
        $micToggle.textContent = LANG.mic_enable;
        $micMeter.style.width = '0';
        if (micMeterFrame) { cancelAnimationFrame(micMeterFrame); micMeterFrame = null; }
    }

    function drawMicMeter() {
        if (!micAnalyser || !micEnabled) return;
        var data = new Uint8Array(micAnalyser.frequencyBinCount);
        micAnalyser.getByteFrequencyData(data);
        var sum = 0;
        for (var i = 0; i < data.length; i++) sum += data[i];
        var avg = sum / data.length;
        var pct = Math.min(100, (avg / 128) * 100);
        $micMeter.style.width = pct + '%';
        micMeterFrame = requestAnimationFrame(drawMicMeter);
    }

    $micToggle.addEventListener('click', function() {
        if (micEnabled) disableMic(); else enableMic();
    });

    $micVol.addEventListener('input', function() {
        if (micGain) micGain.gain.value = parseInt(this.value) / 100;
    });
    if (window.__toolSettings) {
        window.__toolSettings.bind('karaoke', $micVol, 'micVol', '100');
    }

    // Reverb buttons
    $reverbBtns.addEventListener('click', function(e) {
        var btn = e.target.closest('.kr-reverb-btn');
        if (!btn) return;
        $reverbBtns.querySelectorAll('.kr-reverb-btn').forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        if (micEnabled) setReverbPreset(btn.dataset.reverb);
        else currentReverb = btn.dataset.reverb;
        if (window.__toolSettings) window.__toolSettings.save('karaoke', 'reverb', btn.dataset.reverb);
    });
    // Restore saved reverb
    if (window.__toolSettings) {
        var savedReverb = window.__toolSettings.load('karaoke', 'reverb', 'off');
        if (savedReverb !== 'off') {
            currentReverb = savedReverb;
            $reverbBtns.querySelectorAll('.kr-reverb-btn').forEach(function(b) {
                b.classList.toggle('active', b.dataset.reverb === savedReverb);
            });
        }
    }

    // ═══════════════════════════════════════
    // MODULE 2: Recording
    // ═══════════════════════════════════════

    // iOS Safari reports isTypeSupported('audio/webm;codecs=opus') === true but
    // cannot DECODE webm, so the old first-recordable loop handed iPhones a
    // format they could record and not play. The shared primitive gates on
    // canPlayType too, which sends iOS to audio/mp4 and leaves every other
    // browser on webm. See reference_playable_rec_mime_primitive.
    function bestMime() {
        var types = ['audio/webm;codecs=opus', 'audio/webm', 'audio/mp4', 'audio/ogg;codecs=opus'];
        if (window.__pickPlayableRecMime) return window.__pickPlayableRecMime(types);
        for (var i = 0; i < types.length; i++) {
            if (MediaRecorder.isTypeSupported(types[i])) return types[i];
        }
        return '';
    }

    // The container the recorder actually produced decides the extension. It
    // used to be hardcoded ".webm", so an iPhone recording (audio/mp4) was
    // saved as song-recording.webm — an mp4 wearing the wrong name, which
    // players either refuse or open by luck.
    // Container first, codec second: "audio/webm;codecs=opus" is a WEBM file,
    // and matching /opus/ before /webm/ named it .ogg (caught by the iOS-profile
    // run, which is exactly the mime Chromium hands back).
    function recExt(mime) {
        if (/webm/i.test(mime)) return 'webm';
        if (/mp4|m4a|aac/i.test(mime)) return 'm4a';
        if (/ogg/i.test(mime)) return 'ogg';
        if (/wav|pcm/i.test(mime)) return 'wav';
        return 'webm';
    }

    function startRecording() {
        if (!micEnabled || !audioCtx) return;

        mixDestination = audioCtx.createMediaStreamDestination();
        mixDelay = null;
        if (recSync) { try { recSync.refresh(); } catch (e) {} }

        // Connect karaoke track to mix — through the latency delay, so the
        // backing lands in the file where the singer heard it.
        if (karaokeGain) { var mt = backingMixTarget(); if (mt) karaokeGain.connect(mt); }

        // Connect the mic (after volume and reverb) to the mix — the same
        // bus the monitor listens to, so what is heard is what is recorded.
        if (micBus) micBus.connect(mixDestination);

        var mime = bestMime();
        var options = mime ? { mimeType: mime } : {};
        recordChunks = [];

        try {
            mediaRecorder = new MediaRecorder(mixDestination.stream, options);
        } catch (e) {
            if (window.__toast) window.__toast(LANG.err_browser, 'error');
            return;
        }

        mediaRecorder.ondataavailable = function(e) {
            if (e.data.size > 0) recordChunks.push(e.data);
        };
        mediaRecorder.onstop = function() {
            var type = (recordChunks[0] && recordChunks[0].type)
                || (mediaRecorder && mediaRecorder.mimeType) || 'audio/webm';
            recordBlob = new Blob(recordChunks, { type: type });
            recordName = String(fileName || 'karaoke').replace(/\.[^.]+$/, '')
                + '-recording.' + recExt(type);
            window.__lastRecType = type;   // test seam: assert name matches container
            var url = URL.createObjectURL(recordBlob);
            $recDl.href = url;
            $recDl.download = recordName;
            $recDl.classList.add('active');
            if (window.__ae) window.__ae('feature_use', {
                slug: 'karaoke', f: 'rec_done',
                sec: Math.round((Date.now() - recordStartTime) / 1000),
                ext: recExt(type), kb: Math.round(recordBlob.size / 1024),
                // what the singer heard; the take itself never carries it
                guide: vocalGuide,
            });
        };

        mediaRecorder.start(100);
        isRecording = true;
        recordStartTime = Date.now();
        if (window.__ae) window.__ae('feature_use', {
            slug: 'karaoke', f: 'rec_start', reverb: currentReverb,
            lat: recLatencyMs, latKind: recLatencyKind, guide: vocalGuide,
        });
        $recBtn.classList.add('recording');
        $recBtn.querySelector('span').innerHTML = '&#9632;';
        $recBtn.lastChild.textContent = ' ' + LANG.rec_stop;
        $recTimer.classList.add('active');
        $recDl.classList.remove('active');
        updateRecTimer();

        // Auto-play if not playing
        if (!isPlaying) togglePlay();
    }

    function stopRecording() {
        if (mediaRecorder && mediaRecorder.state !== 'inactive') {
            mediaRecorder.stop();
        }
        isRecording = false;
        if (recordTimerInterval) { clearInterval(recordTimerInterval); recordTimerInterval = null; }

        $recBtn.classList.remove('recording');
        $recBtn.querySelector('span').innerHTML = '&#9679;';
        $recBtn.lastChild.textContent = ' ' + LANG.rec_start;

        // Disconnect mix destination extras
        if (mixDestination) {
            try { if (karaokeGain && mixDelay) karaokeGain.disconnect(mixDelay); } catch(e) {}
            try { if (mixDelay) mixDelay.disconnect(); } catch(e) {}
            try { if (micBus) micBus.disconnect(mixDestination); } catch(e) {}
            mixDestination = null;
            mixDelay = null;
        }
    }

    function updateRecTimer() {
        recordTimerInterval = setInterval(function() {
            if (!isRecording) return;
            var elapsed = (Date.now() - recordStartTime) / 1000;
            $recTimer.textContent = formatTime(elapsed);
        }, 200);
    }

    $recBtn.addEventListener('click', function() {
        // startRecording() used to just return when the mic was off, so this
        // button did nothing at all and said nothing about why.
        if (!isRecording && !micEnabled) {
            if (window.__toast) window.__toast(LANG.rec_needs_mic, 'warning');
            if ($micToggle) $micToggle.focus();
            return;
        }
        if (isRecording) stopRecording(); else startRecording();
    });

    // The download goes through the shared primitive: a bare <a download
    // href="blob:"> is a silent no-op in Android WebView. href stays set so the
    // link is still a real link for keyboard/context-menu use.
    $recDl.addEventListener('click', function(e) {
        if (!recordBlob || !window.__downloadFile) return;
        e.preventDefault();
        window.__downloadFile(recordBlob, recordName || 'karaoke-recording.webm');
        if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'rec_download' });
    });

    // ═══════════════════════════════════════
    // MODULE 3: LRC Synced Lyrics
    // ═══════════════════════════════════════

    // Seek the karaoke track to an absolute time (used by lyric-line clicks).
    /** @param timeS ORIGINAL song seconds — lyric lines are authored in that base. */
    function seekToTime(timeS) {
        if (!musicBuffer) return;
        var wasPlaying = isPlaying;
        if (isPlaying) stopPlayback(true);
        var dur = playbackDuration();
        pauseOffset = Math.max(0, Math.min(toPlaybackTime(timeS), dur));
        pxWrite($cursor, 'left', (pauseOffset / dur) * 100);
        textWrite($timeCur, formatTime(pauseOffset));
        if (wasPlaying) startPlayback();
    }

    // LRC parsing / rendering / sync is delegated to the shared KaraokeLyrics
    // module — the single source of truth for the lyric timeline (also used by
    // the sync editor and video export). lrcLines is a timeline of
    // {startS, endS, text, words?}.
    function updateLRCHighlight(currentTime) {
        if (window.KaraokeLyrics) window.KaraokeLyrics.update($lrcDisplay, lrcLines, currentTime);
    }

    // Once the words are in, the stage shows the words — the search boxes,
    // the file picker and the raw-LRC textarea collapse behind "edit". They
    // are how you load lyrics, not what you sing off.
    var $lyricsBox = document.getElementById('krLyrics');
    function setLyricsLoaded(on) {
        if ($lyricsBox) $lyricsBox.classList.toggle('has-lrc', !!on);
    }
    var $lrcEditBtn = document.getElementById('krLrcEdit');
    if ($lrcEditBtn) $lrcEditBtn.addEventListener('click', function () { setLyricsLoaded(false); });

    function loadLRCText(text) {
        var parsed = window.KaraokeLyrics
            ? window.KaraokeLyrics.parseLRC(text)
            : { lines: [] };
        lrcLines = parsed.lines;
        if (lrcLines.length > 0) {
            lrcActive = true;
            lrcCurrentIndex = -1;
            window.KaraokeLyrics.render($lrcDisplay, lrcLines, { onSeek: seekToTime });
            $lrcStatus.textContent = LANG.lyrics_synced + ' (' + lrcLines.length + ')';
            $lrcStatus.className = 'kr-lrc-status success';
            setLyricsLoaded(true);
        } else {
            lrcActive = false;
            $lrcDisplay.innerHTML = '';
            $lrcStatus.textContent = LANG.lyrics_no_sync;
            $lrcStatus.className = 'kr-lrc-status error';
            setLyricsLoaded(false);
        }
    }

    // LRC / karaoke-file upload — .lrc, plain .txt, UltraStar .txt, MIDI/.kar.
    // MIDI + UltraStar carry note timing too; importedNotes feeds scoring.
    var importedNotes = null;

    function applyImportedTimeline(result) {
        importedNotes = (result.notes && result.notes.length) ? result.notes : null;
        lrcLines = result.timeline || [];
        if (lrcLines.length && window.KaraokeLyrics) {
            lrcActive = true;
            lrcCurrentIndex = -1;
            window.KaraokeLyrics.render($lrcDisplay, lrcLines, { onSeek: seekToTime });
            $lrcStatus.textContent = LANG.lyrics_synced + ' (' + lrcLines.length + ')';
            $lrcStatus.className = 'kr-lrc-status success';
            setLyricsLoaded(true);
            scoreReference = null;   // a new import replaces any built reference
            if (window.__ae) window.__ae('feature_use', {
                slug: 'karaoke', f: 'karaoke_file_import',
                lines: lrcLines.length, notes: importedNotes ? importedNotes.length : 0,
            });
        } else {
            $lrcStatus.textContent = LANG.lyrics_no_sync;
            $lrcStatus.className = 'kr-lrc-status error';
        }
    }

    $lrcFile.addEventListener('change', function() {
        if (!this.files.length) return;
        var file = this.files[0];
        var ext = file.name.split('.').pop().toLowerCase();
        var isMidi = (ext === 'mid' || ext === 'midi' || ext === 'kar');
        var reader = new FileReader();
        reader.onload = function(e) {
            try {
                if (isMidi && window.KaraokeImport) {
                    applyImportedTimeline(window.KaraokeImport.parseMidi(e.target.result));
                } else {
                    // Bytes, not readAsText: a windows-1251 .lrc (still common
                    // for Russian lyrics) decoded as UTF-8 is a wall of "\uFFFD".
                    var text = window.KaraokeLyrics && window.KaraokeLyrics.decodeBytes
                        ? window.KaraokeLyrics.decodeBytes(e.target.result)
                        : new TextDecoder('utf-8').decode(e.target.result);
                    if (window.KaraokeImport && /^#BPM:/m.test(text)) {
                        applyImportedTimeline(window.KaraokeImport.parseUltraStar(text));
                    } else {
                        $lrcPaste.value = text;
                        loadLRCText(text);
                        if (window.__ae) window.__ae('feature_use', {
                            slug: 'karaoke', f: 'lyrics_ready', src: 'file', ext: ext.slice(0, 6),
                        });
                    }
                }
            } catch (err) {
                console.warn('Karaoke import failed:', err && err.message);
                if (window.__toast) window.__toast(LANG.import_error || '', 'error');
            }
        };
        reader.readAsArrayBuffer(file);   // one path for MIDI and text alike
    });

    var $lrcShift = document.getElementById('krLrcShift');
    if ($lrcShift) $lrcShift.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('[data-lrc-shift]') : null;
        if (!b || !lrcLines.length || !window.KaraokeLyrics) return;
        var d = parseFloat(b.dataset.lrcShift);
        lrcLines = window.KaraokeLyrics.shift(lrcLines, d);
        window.KaraokeLyrics.render($lrcDisplay, lrcLines, { onSeek: seekToTime });
        // Keep the textarea (what "Save song" stores) in step with what is shown.
        if ($lrcPaste) $lrcPaste.value = window.KaraokeLyrics.serializeLRC(lrcLines);
        if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'lyrics_shift', by: d, src: 'lrc' });
    });

    /* The file's TIMES may be for another cut of the song; its WORDS are not.
       Hand the words to the plain tab and place them on this recording's voice. */
    var $lrcReplace = document.getElementById('krLrcReplace');
    if ($lrcReplace) $lrcReplace.addEventListener('click', function () {
        if (!lrcLines.length) return;
        $lyricsText.value = lrcLines.map(function (l) { return l.text; }).join('\n');
        saveSongLyrics();
        var plainTab = document.querySelector('.kr-lyrics-mode-btn[data-mode="plain"]');
        if (plainTab) plainTab.click();
        refreshPlainLyrics();
        if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'lrc_replace_on_voice', lines: lrcLines.length });
        if ($asStart && !plainLrcLines.length) $asStart.click();
    });

    // LRC paste
    var lrcPasteTimeout;
    $lrcPaste.addEventListener('input', function() {
        clearTimeout(lrcPasteTimeout);
        lrcPasteTimeout = setTimeout(function() {
            loadLRCText($lrcPaste.value);
        }, 500);
    });

    // ── Online synced-lyrics search (lrclib.net) ──
    var $lrcArtist = document.getElementById('krLrcArtist');
    var $lrcTrack = document.getElementById('krLrcTrack');
    var $lrcSearchBtn = document.getElementById('krLrcSearchBtn');
    var $lrcSearchStatus = document.getElementById('krLrcSearchStatus');
    var $lrcResults = document.getElementById('krLrcResults');

    function runLrcSearch() {
        if (!window.KaraokeLyrics || !$lrcSearchBtn) return;
        var artist = $lrcArtist.value.trim();
        var track = $lrcTrack.value.trim();
        if (!artist && !track) {
            $lrcSearchStatus.textContent = LANG.lrc_search_none || '';
            return;
        }
        $lrcSearchBtn.disabled = true;
        $lrcResults.innerHTML = '';
        $lrcSearchStatus.textContent = LANG.lrc_searching || '';
        if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'lrc_search' });
        window.KaraokeLyrics.searchLRC({ artist: artist, track: track }).then(function (results) {
            $lrcSearchBtn.disabled = false;
            if (!results.length) { $lrcSearchStatus.textContent = LANG.lrc_search_none || ''; return; }
            $lrcSearchStatus.textContent = '';
            // The same song comes in many cuts (album, radio edit, live, a video
            // with an intro), and a found .lrc is timed against ONE of them —
            // two of eight pairs measured 18.09 were 12 s and 48 s off. The cut
            // whose length matches this file is the likely one: it goes first
            // and says so.
            var dur = originalBuffer ? originalBuffer.duration : 0;
            if (dur) {
                results = results.slice().sort(function (a, b) {
                    return Math.abs((a.duration || 1e9) - dur) - Math.abs((b.duration || 1e9) - dur);
                });
            }
            results.forEach(function (res) {
                var row = document.createElement('div');
                row.className = 'kr-lrc-result';
                var title = document.createElement('div');
                title.className = 'kr-lrc-result-title';
                title.textContent = res.artist + ' — ' + res.track;
                var meta = document.createElement('div');
                meta.className = 'kr-lrc-result-meta';
                meta.textContent = res.duration ? formatTime(res.duration) : '';
                if (dur && res.duration && Math.abs(res.duration - dur) <= 3) {
                    var m = document.createElement('span');
                    m.className = 'kr-lrc-result-match';
                    m.textContent = ' · ' + (LANG.lrc_match_length || '');
                    meta.appendChild(m);
                }
                row.appendChild(title);
                row.appendChild(meta);
                row.addEventListener('click', function () {
                    $lrcPaste.value = res.syncedLyrics;
                    loadLRCText(res.syncedLyrics);
                    $lrcResults.innerHTML = '';
                    $lrcSearchStatus.textContent = '';
                    if (window.__ae) window.__ae('feature_use', { slug: 'karaoke', f: 'lrc_search_apply' });
                });
                $lrcResults.appendChild(row);
            });
        }).catch(function (err) {
            $lrcSearchBtn.disabled = false;
            $lrcSearchStatus.textContent = LANG.lrc_search_error || '';
            console.warn('lrclib search failed:', err && err.message);
        });
    }
    if ($lrcSearchBtn) $lrcSearchBtn.addEventListener('click', runLrcSearch);
    [$lrcArtist, $lrcTrack].forEach(function (inp) {
        if (inp) inp.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') { e.preventDefault(); runLrcSearch(); }
        });
    });

    /* ── «Find the timed words of THIS song» ────────────────────────────────
       The file usually names its song — tags, or «Artist - Title.mp3» — and the
       open database has timed words for most known songs (34 of 40 popular
       Russian ones checked 30.09.2026). Timed words from there need no model
       download at all. The search sat on the second tab behind two empty
       fields (17 sessions in 30 days used it), so the stage offers it under an
       empty sheet, already filled in. It searches only when pressed: the name
       of a person's file leaves the page on their word, not on its own. */
    var $findLrc = document.getElementById('krFindLrc');
    var songGuess = null;             // { artist, track, fromTags }

    function guessSongFromName(name) {
        var base = String(name || '').replace(/\.[^.]+$/, '').replace(/_+/g, ' ').replace(/\s+/g, ' ').trim();
        base = base.replace(/^\d{1,3}\s*[-.)]\s+/, '');             // «01 - », «02. »
        var parts = base.split(/\s+[-–—]\s+/);
        if (parts.length >= 2 && parts[0] && parts[1]) {
            return { artist: parts[0].trim(), track: parts.slice(1).join(' - ').trim(), fromTags: false };
        }
        return base ? { artist: '', track: base, fromTags: false } : null;
    }

    function noteSongForLrcSearch(file) {
        songGuess = guessSongFromName(file && file.name);
        var T = window.__audioSourceTags;
        if (file && T && typeof T.readTags === 'function') {
            T.readTags(file).then(function (tags) {
                if (!tags || !tags.title || songKey !== songLyricsKey(file)) return;
                songGuess = { artist: tags.artist || '', track: tags.title, fromTags: true };
                updateFindLrcButton();
            }, function () {});
        }
        updateFindLrcButton();
    }

    function updateFindLrcButton() {
        if (!$findLrc) return;
        var show = !!(songGuess && songGuess.track) && !plainLines().length && lyricsMode === 'plain';
        $findLrc.hidden = !show;
        if (show) {
            $findLrc.textContent = '🔎 ' + String(LANG.lrc_find_for || '')
                .replace(':title', (songGuess.artist ? songGuess.artist + ' — ' : '') + songGuess.track);
        }
    }

    if ($findLrc) $findLrc.addEventListener('click', function () {
        if (!songGuess) return;
        if ($lrcArtist) $lrcArtist.value = songGuess.artist || '';
        if ($lrcTrack) $lrcTrack.value = songGuess.track || '';
        var lrcTab = document.querySelector('.kr-lyrics-mode-btn[data-mode="lrc"]');
        if (lrcTab) lrcTab.click();
        setLyricsLoaded(false);
        if (window.__ae) window.__ae('feature_use', {
            slug: 'karaoke', f: 'lrc_find_click', tags: songGuess.fromTags ? 1 : 0,
            artist: songGuess.artist ? 1 : 0, pending: songPending ? 1 : 0,
        });
        runLrcSearch();
    });

    // ═══════════════════════════════════════
    // MODULE 4: A-B Loop
    // ═══════════════════════════════════════

    function updateLoopVisuals() {
        if (!musicBuffer) return;
        // loopA/loopB come from getCurrentElapsed() — playback time base.
        var dur = playbackDuration();

        if (loopA !== null) {
            var pctA = (loopA / dur) * 100;
            $loopMarkerA.style.left = pctA + '%';
            $loopMarkerA.classList.add('active');
            $loopA.classList.add('active');
        } else {
            $loopMarkerA.classList.remove('active');
            $loopA.classList.remove('active');
        }

        if (loopB !== null) {
            var pctB = (loopB / dur) * 100;
            $loopMarkerB.style.left = pctB + '%';
            $loopMarkerB.classList.add('active');
            $loopB.classList.add('active');
        } else {
            $loopMarkerB.classList.remove('active');
            $loopB.classList.remove('active');
        }

        if (loopEnabled && loopA !== null && loopB !== null) {
            var pctA2 = (loopA / dur) * 100;
            var pctB2 = (loopB / dur) * 100;
            $loopRegion.style.left = pctA2 + '%';
            $loopRegion.style.width = (pctB2 - pctA2) + '%';
            $loopRegion.classList.add('active');
            $loopBadge.classList.add('active');
            $loopClear.classList.remove('hidden');
        } else {
            $loopRegion.classList.remove('active');
            $loopBadge.classList.remove('active');
        }
    }

    /* Playback position in PLAYBACK seconds (the processed buffer's time base).
       The buffer plays at 1.0×, so this is plain wall time since start. */
    function getCurrentElapsed() {
        if (!isPlaying || !audioCtx) return pauseOffset;
        return audioCtx.currentTime - startTime;
    }

    $loopA.addEventListener('click', function() {
        loopA = getCurrentElapsed();
        loopB = null;
        loopEnabled = false;
        $loopB.disabled = false;
        $loopClear.classList.add('hidden');
        updateLoopVisuals();
    });

    $loopB.addEventListener('click', function() {
        if (loopA === null) return;
        loopB = getCurrentElapsed();
        if (loopB <= loopA) {
            var tmp = loopA;
            loopA = loopB;
            loopB = tmp;
        }
        if (loopB - loopA < 0.5) { loopB = null; return; }
        loopEnabled = true;
        updateLoopVisuals();
    });

    $loopClear.addEventListener('click', function() {
        loopA = null;
        loopB = null;
        loopEnabled = false;
        $loopB.disabled = true;
        $loopClear.classList.add('hidden');
        $loopMarkerA.classList.remove('active');
        $loopMarkerB.classList.remove('active');
        $loopRegion.classList.remove('active');
        $loopBadge.classList.remove('active');
        $loopA.classList.remove('active');
        $loopB.classList.remove('active');
    });

    // ═══════════════════════════════════════
    // Keyboard Shortcuts
    // ═══════════════════════════════════════

    document.addEventListener('keydown', function(e) {
        if (!musicBuffer) return;
        var tag = (e.target.tagName || '').toLowerCase();
        if (window.__keyOwnedByFocus ? window.__keyOwnedByFocus(e) : (tag === 'input' || tag === 'textarea' || tag === 'select' || e.target.isContentEditable)) return;

        if (e.code === 'Space') {
            // While the sync editor is open the Space key belongs to the
            // focused Tap button (native activation) — don't also toggle play.
            if (syncEditorOpen) return;
            e.preventDefault();
            togglePlay();
        } else if (e.code === 'ArrowLeft') {
            e.preventDefault();
            pauseOffset = Math.max(0, getCurrentElapsed() - 5);
            // keepOffset: a bare stopPlayback() writes the CURRENT position back into
            // pauseOffset, i.e. over the target computed one line above — so the
            // arrows did nothing at all while the song was playing (18.09.2026).
            if (isPlaying) { stopPlayback(true); startPlayback(); }
            else { pxWrite($cursor, 'left', (pauseOffset / playbackDuration()) * 100); textWrite($timeCur, formatTime(pauseOffset)); }
        } else if (e.code === 'ArrowRight') {
            e.preventDefault();
            pauseOffset = Math.min(playbackDuration(), getCurrentElapsed() + 5);
            // keepOffset: a bare stopPlayback() writes the CURRENT position back into
            // pauseOffset, i.e. over the target computed one line above — so the
            // arrows did nothing at all while the song was playing (18.09.2026).
            if (isPlaying) { stopPlayback(true); startPlayback(); }
            else { pxWrite($cursor, 'left', (pauseOffset / playbackDuration()) * 100); textWrite($timeCur, formatTime(pauseOffset)); }
        } else if (e.code === 'KeyR' && micEnabled) {
            e.preventDefault();
            if (isRecording) stopRecording(); else startRecording();
        }
    });

    // ── New file ──
    $newBtn.addEventListener('click', function() {
        if ($upload.__uploaderReset) $upload.__uploaderReset();
        if ($upload.__uploaderOpen) $upload.__uploaderOpen();
    });

    // ── Helpers ──
    function formatTime(sec) {
        if (!sec || isNaN(sec)) return '0:00';
        var m = Math.floor(sec / 60);
        var s = Math.floor(sec % 60);
        return m + ':' + (s < 10 ? '0' : '') + s;
    }

    // Redraw on resize
    var resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            if (musicBuffer) {
                drawWaveform($canvas, musicBuffer, '#38bdf8');
                updateLoopVisuals();
            }
        }, 200);
    });

    // Readiness sentinel — the orchestrator IIFE ran to completion and every
    // listener (uploader, controls, lyrics, sync editor) is wired.
    window.__karaokeReady = true;
})();
});
